// Basic Vue components
import { createApp } from 'vue'
import 'vue-style-loader';

// Setup Vue
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Event Bus
window.EventBus = new class {
    constructor() {
        this.vue = window.createApp;
    }

    emit(event, data = null) {
        // console.log("event called!");
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        // console.log("event found!");
        this.vue.$on(event, callback);
    }
};

// Our extensions and components
import Axios from './classes/Axios.js';
import autocomplete from './components/autocomplete.vue';
import searchResource from './components/searchResource.vue';
import modalDynamic from './components/modal-dynamic.vue';
import calendar from './components/calendar.vue';
import oasisModal from './components/oasis-modal.vue';
import signaturePad from './components/signaturePad.vue';
import UtilitiesMixin from './mixins/UtilitiesMixin';
import COAMixin from './mixins/COAMixin.js';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
import addressAutocomplete from './components/addressAutocomplete.vue';
import AgGrid from './components/AgGrid.vue';
import IntlMixin from './mixins/IntlMixin.js';
import DateFormatUtil from './mixins/DateFormatUtil.js';
import {DateTime} from 'luxon'
require ('./classes/PrototypeExt.js');

var app = createApp({

    components: {
      autocomplete,
      'search-resource': searchResource,
      calendar,
      'modal-dynamic': modalDynamic,
      'signature-pad': signaturePad,
      'oasis-modal': oasisModal,
      Multiselect,
      'address-autocomplete': addressAutocomplete,
      AgGrid
    },

    mixins: [ UtilitiesMixin, IntlMixin, COAMixin, DateFormatUtil ],

    data() {
        return {
            enableWorkDay: false,
            rateUnits: rateUnits,
            union_local_pointer: 0,
            allowanceMessage : false,
            allowanceLocType: [
                {id: 0, name: 'All'},
                {id: 1, name: 'Studio/Rep To/Bus To'},
                {id: 2, name: 'Distant'}
            ],
            multiSelectMissing: false,
            multiSelectChanged: false,
            filteredUnionByLocation: [],
            locationFilterToggle: false,
            hasPrepWrap: false,
            isFirstEdit: false,
            allUserId: [], // to use on cellEditor
            allUserbyEntity: new Map(), // to get removed duplicated User data that is come from UserRoleMx
            changedRow: new Map(), // to detect grid changes whwen we update all changes.
            defaultDeptModal: false,
            allApproverByEntity: [],
            retrieveApproverByDept: [],
            retrieveDefaultApprover: [],
            deptChanged: false,
            gridChanged: false,
            deptApproverWorkflow: 0,
            isWorkflowChanged: false, // to get recent data If data was changed
            viewDepartModal: false,
            rowData: [],
            iteration:0,
            gridOptions: {
                singleClickEdit: true,
                enterMovesDown: true,
                stopEditingWhenGridLosesFocus: true,
                enterMovesDownAfterEdit: true,
                alwaysShowHorizontalScroll: true,
                overlayNoRowsTemplate: '<h3 style="text-align: center;">The default department approval workflow will be applied.</h3>',
                defaultColDef: {
                    resizable: true,
                },
                rowSelection: 'single',
                editType: 'fullRow',
                onGridReady: (event) => this.$refs['viewDept'].onGridReady(event),
                onRowValueChanged: (event) => this.isGridChanged(event),
            },
            columnDefs: [
                {
                    field: 'user_id',
                    sortable: true,
                    editable: (params) => this.deptApproverWorkflow == 1 ? true : false,
                    minWidth: 50,
                    maxWidth: 200,
                    headerName: 'Username',
                    cellEditor: 'agSelectCellEditor',
                    valueFormatter: (params) => {
                        if (!params || !params.value) return;
                        return this.getUserName(params);
                     },
                     cellEditorParams: () => ({
                        values: this.allUserId
                    }),
                    cellStyle: params => {
                        if (!params.data.user_id) return {'background-color': '#FFFF66'}
                        else if (!params.data.department_id) return {'background-color': '#D3D3D3'}
                        return null;
                    },
                    //cellClassRules: this.deptWorkFlowCellClassRules,
                    valueGetter: (params) => params.data.user_id,
                    valueSetter: (params) => {
                        params.data.user_id = params.newValue;
                    },
                    //cellEditor: 'autocomplete',
                    /*cellEditorParams: {
                        options: sss
                    },*/
                },
                {
                    field: 'approver_group',
                    sortable: true,
                    editable: (params) => this.deptApproverWorkflow == 1 ? true : false,
                    headerName: 'Tier',
                    minWidth: 50,
                    maxWidth: 100,
                    sort: 'asc',
                    initialSortIndex: 1,
                    cellStyle: params => {
                        if (!params.data.approver_group && params.data.approver_type != 3) return {'background-color': '#FFFF66'}
                        else if (!params.data.department_id) return {'background-color': '#D3D3D3'}
                        return null;
                    },
                    valueFormatter: (params) => params.value || 'N/A',
                    valueSetter: (params) => {
                        params.data.approver_group = params.newValue || null
                    },
                    valueGetter: (params) => params.data.approver_group,
                },
                {
                    field: 'approver_type',
                    sortable: true,
                    cellStyle: params => {
                        if (!params.data.department_id) return {'background-color': '#D3D3D3'}
                        return null;
                    },
                    editable: (params) => this.deptApproverWorkflow == 1 ? true : false,
                    headerName: 'Approver Type',
                    minWidth: 80,
                    maxWidth: 180,
                    sort: 'asc',
                    initialSortIndex: 2,
                    valueFormatter: (params) => {
                        if (!params || typeof params.value === 'undefined') return null
                        switch (String(params.value)) {
                            case '0':
                                return 'Both'

                            case '1':
                                return 'Timecards'

                            case '2':
                                return 'Starts'

                            case '3':
                                return 'Observer'

                            default:
                                return 'None/Error'
                        }
                    },
                    valueSetter: (params) => {
                        if (!params || typeof params.newValue === 'undefined') return null
                        if (params.newValue === '3') {
                            params.data.approver_group = null;
                            params.data.final_approver = '0';
                            params.data.send_notifications = '0';
                        }
                        params.data.approver_type = params.newValue
                    },
                    valueGetter: (params) => params.data.approver_type,
                    cellEditor: 'agSelectCellEditor',
                    cellEditorParams: {
                        values: ['0', '1', '2', '3'],
                    },
                },
                {
                    field: 'final_approver',
                    sortable: true,
                    editable: (params) => this.deptApproverWorkflow == 1 ? true : false,
                    headerName: 'Bypass',
                    minWidth: 80,
                    maxWidth: 100,
                    valueFormatter: (params) => {
                       if (params.value == 0) return 'No'
                       else return 'Yes'
                    },
                    cellStyle: params => {
                        if (!params.data.department_id) return {'background-color': '#D3D3D3'}
                        return null;
                    },
                    valueSetter: (params) => {
                        params.data.final_approver = params.newValue
                    },
                    valueGetter: (params) => params.data.final_approver,
                    cellEditor: 'agSelectCellEditor',
                    cellEditorParams: {
                        values: ['0', '1'],
                    },
                },
                {
                    field: 'send_notifications',
                    sortable: true,
                    editable: (params) => this.deptApproverWorkflow == 1 ? true : false,
                    headerName: 'Notifications (this tier)',
                    minWidth: 50,
                    width: 130,
                    maxWidth: 200,
                    valueFormatter: (params) => {
                        if (params.value == 0) return 'No'
                        else return 'Yes'
                     },
                    cellStyle: params => {
                        if (!params.data.department_id) return {'background-color': '#D3D3D3'}
                        return null;
                    },
                    valueSetter: (params) => {
                        params.data.send_notifications = params.newValue
                    },
                    valueGetter: (params) => params.data.send_notifications,
                    cellEditor: 'agSelectCellEditor',
                    cellEditorParams: {
                        values: ['1', '0'],
                    },
                },
                {
                    field: 'status',
                    sortable: true,
                    editable: (params) => this.deptApproverWorkflow == 1 ? true : false,
                    headerName: 'Status',
                    minWidth: 30,
                    maxWidth: 80,
                    valueFormatter: (params) => {
                        if (params.value == 0) return 'Inactive'
                        else return 'Active'
                     },
                    cellStyle: params => {
                        if (!params.data.department_id) return {'background-color': '#D3D3D3'}
                        return null;
                    },
                    valueSetter: (params) => {
                        params.data.status = params.newValue
                    },
                    valueGetter: (params) => params.data.status,
                    cellEditor: 'agSelectCellEditor',
                    cellEditorParams: {
                        values: ['1', '0'],
                    },
                },
            ],
            isNewLocationUpdated: false,
            isNewLocationOverride: false,
            isNewLocationAddressChanged: false,
            error_newLocation_address1: '',
            error_newLocation_city: '',
            error_newLocation_state: '',
            error_newLocation_generic: '',
            error_newLocation_postal: '',
            selectedAgreementLocal:'',
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            type: undefined,  // create/edit
            waiting: true, // whole-page spinner
            loading: false, // small loading spinner
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
            selectedUnionJobs: [],
            resetJobInfoToggle: true,
            enableProBooks: false,
            probooksAccounts: '',
            probooksFreeFields: '',
            probooksSeries: '',
            probooksLocations: '',
            probooksSets: '',
            probooksProjects: '',
            
            // autocomplete
            selected_budget_code: '',
            selected_fringe_code: '',
            selected_free_field: '',
            selected_free_field2: '',
            selected_series_code: '',
            selected_location_code: '',
            selected_set_code: '',
            selected_pw_budget_code: '',
            selected_pw_fringe_code: '',
            selected_pw_free_field: '',
            selected_pw_free_field2: '',
            selected_pw_series_code: '',
            selected_pw_location_code: '',
            selected_pw_set_code: '',
            selected_kr_code: '',
            selected_kr_free_field: '',
            selected_kr_free_field2: '',
            selected_krtax_code: '',
            selected_krtax_free_field: '',
            selected_krtax_free_field2: '',
            selected_pd_code: '',
            selected_pd_free_field: '',
            selected_pd_free_field2: '',
            selected_pd_taxable_code: '',
            selected_pdtax_free_field: '',
            selected_pdtax_free_field2: '',
            selected_lodging_code: '',
            selected_lodging_free_field: '',
            selected_lodging_free_field2: '',
            selected_lodging_tax_code: '',
            selected_lodging_tax_free_field: '',
            selected_lodging_tax_free_field2: '',
            selected_phone_allow_code: '',
            selected_phone_allow_free_field: '',
            selected_phone_allow_free_field2: '',
            selected_cr_code: '',
            selected_cr_free_field: '',
            selected_cr_free_field2: '',
            selected_agent_code: '',
            selected_agent_free_field: '',
            selected_agent_free_field2: '',


            entityId: entityId,
            empSet: undefined,
            error_message: '',
            editCompletedStartModal: false, // Show the approval modal?
            keyFieldsChanged: undefined,
            preEditAssignment: undefined,
            preEditAllowances: undefined,
            preEditCaps: undefined,
            editingCompletedStart: false, // Tell the save mechanism to update start
            employerMessage: '', // For the editCompletedStart modal
            locationModal: false, // Show the add location modal?
            departmentModal: false, // Show the add department modal?
            empLocked: false, // make the employee read only?
            rateUnitLocked: false,
            guaranteedUnitLocked: false,
            minimumGuarantee: 0,
            modified: false,
            startCalendar: false,
            existingStart: false,
            union: false,
            local: '',
            noUnionJobMatch: false,
            oasisApi: new Axios('/restv2'),
            oasisV3Api: new Axios('/restv3'),
            adminAccess: false,

            // employees/locations retrieved from database
            entity: [],
            allowedUnionRuleCollections: [], // Entity properties
            allowedNonUnionRuleCollections: [], // Entity properties
            employees: [],
            states: [],
            legislativeTypes: [],
            ruleCollections: [],
            disabledRateUnits: [],
            disabledFlsaTypes: ["3", "4"],  // Don't enable union by default
            disabledLegislativeTypes: ["3", "4"],  // Don't enable union by default
            projectLocations: [],
            departments: [],
            allJobs: [],
            allUnionHiredFrom: [],
            agreements: [],
            agreementLocals: [],
            unionLocals: [],
            unionJobs: [],
            unionJobRules: [],
            unionSchedules: [],
            unionLocations: [],
            unionOnProd: [],
            unionJobRuleMx: {},
            locals: [],
            scale: null,
            scaleMessage: '',
            scaleType: '',
            productionCity: false,
            minWage: {},
            customForms: customForms,
            selectedCustomForms: [],
            harassmentCertification: false,
            companyHarassmentSupCertificateId: undefined,
            companyHarassmentCertificateId: undefined,
            disableLoanouts: null, 
            enableLoanoutsEmployee: null, 
            allowanceRateUnits: [],
            defaultRateUnits: {},
            coaRules: [],
 
            // Employee Details
            employee: {
                id: '',
                last_name: '',
                first_name: '',
                email: '',
                tin: '',
                foreign_tin: '',
                special_type: '',
                main_state_id: '',
                show_agent: '',
                metadata: {},
                special_type_properties: {}
            },

            // Calendar opts:
            disabled: [],
            format: 'MM/dd/yyyy',
            clear: false,
            placeholder: 'Click to select week ending',
            calendar: {
                start_date: false,
                term_date: false
            },

            // Signature Pad
            signatureOptions: {},

            // Assignment details
            assignmentOriginal: undefined,
            assignment: {
                id: '',
                start_date: '',
                term_date: '',
                is_paid_scale: false,
                rate: '',
                rate_unit_id: '',
                guaranteed_hours: '',
                guaranteed_hours_unit_id: '8',
                guaranteed_hours_6th: '',
                guaranteed_hours_7th: '',
                pd_rate_unit_id: '',
                lodging_rate_unit_id: '',
                kit_rate_unit_id: '',
                phone_rate_unit_id: '',
                car_rate_unit_id: '',
                hourly_rate: '',
                scale_rate: null,
                scale_stn: null,
                rate_comment: '',
                job_order: 1,
                job_title: '',
                job_title_id: '',
                job_title_override: '',
                flsa_type_id: 1,
                legislative_type_id: '',
                loanout_status: '0',
                currency: 'USD',
                currency_id: 1,
                rule_collection_id: '',
                location_id: '',
                department_id: '',
                aca_status_id: '',
                employee: '',
                employee_id: '',
                is_supervisor: '',
                certification_type_id: null,
                entity:'',
                entity_id:'',
                budget_code: '',
                fringe_code: '',
                series_code: '',
                location_code: '',
                set_code: '',
                free_field: '',
                free_field2: '',
                kit_rental: '',
                kit_rental_tax: '',
                per_diem: '',
                per_diem_taxable: '',
                lodging: '',
                lodging_tax: '',
                phone_allow: '',
                per_diem_advance: '',
                car_rental: '',
                other: '',
                agent_fee: '',
                mileage: '',
                mileage_rate: '',
                kr_code: '',
                krtax_code: '',
                pd_code: '',
                pd_taxable_code: '',
                lodging_code: '',
                lodging_tax_code: '',
                phone_allow_code: '',
                pd_advance_code: '',
                cr_code: '',
                mi_code: '',
                other_code: '',
                agent_code: '',
                kr_free_field: '',
                krtax_free_field: '',
                pd_free_field: '',
                pdtax_free_field: '',
                lodging_free_field: '',
                lodging_tax_free_field: '',
                phone_allow_free_field: '',
                pdadv_free_field: '',
                cr_free_field: '',
                mi_free_field: '',
                other_free_field: '',
                agent_free_field: '',
                kr_free_field2: '',
                krtax_free_field2: '',
                pd_free_field2: '',
                pdtax_free_field2: '',
                lodging_free_field2: '',
                lodging_tax_free_field2: '',
                phone_allow_free_field2: '',
                pdadv_free_field2: '',
                cr_free_field2: '',
                mi_free_field2: '',
                other_free_field2: '',
                agent_free_field2: '',
                kr_cap: '',
                krtax_cap: '',
                cr_cap: '',
                phone_cap: '',
                status: '',
                occ_code: '',
                agreement: '',
                agreement_id: '',
                resident_state: '',
                resident_state_id: '',
                union_local: '',
                union_local_id: '',
                union_ruleset_id: '',
                union_flsa_type_id: '',
                custom_forms: {},
                custom_form_fields: {},
                custom_form_employer_fields: {},
                employer_comments: '',
                recurring_comments: '',
                union_hired_from_id: '80',
                union_schedule_id: '',
                union_location_id: '',
                union_on_prod_id: '',
                union_rule_overrides: { studio: null, distant: null, busto: null, reportto: null, studiodistant: null},
                is_rehire: null,
                i9_verifier_id: null,
                i9_verified_date: null,
                list_a_type_id: null,
                list_a_auth: null,
                list_a_number: null,
                list_a_exp: null,
                list_b_type_id: null,
                list_b_auth: null,
                list_b_number: null,
                list_b_exp: null,
                list_c_type_id: null,
                list_c_auth: null,
                list_c_number: null,
                list_c_exp: null,
                ee_list_a_type_id: null,
                ee_list_a_auth: null,
                ee_list_a_number: null,
                ee_list_a_exp: null,
                ee_list_b_type_id: null,
                ee_list_b_auth: null,
                ee_list_b_number: null,
                ee_list_b_exp: null,
                ee_list_c_type_id: null,
                ee_list_c_auth: null,
                ee_list_c_number: null,
                ee_list_c_exp: null,
                fed_jobcategory_id: null,
                ca_jobcategory_id: null,
                metadata: {},
                pw_budget_code: '',
                pw_fringe_code: '',
                pw_free_field: '',
                pw_free_field2: '',
                pw_series_code: '',
                pw_location_code: '',
                pw_set_code: '',
                kr_loc_type: 0,
                krtax_loc_type: 0,
                phone_loc_type: 0,
                pd_loc_type: 0,
                pd_taxable_loc_type: 0,
                lodging_loc_type: 0,
                lodging_tax_loc_type: 0,
                cr_loc_type: 0,
                work_day: 0,
            },

            // New Location
            newLocation: {
                default: 0,
                entity_id: entityId,
                id: '',
                status: 1,
                default: '0',
                name: '',
                description: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                state_id: '',
                postal: '',
                country: 'US',
                country_id: 1,
                defaultState: {},
                union_jurisdiction_id: null,
                is_studio: 0,
                transport_method_id: null,
            },

            // New Department
            newDepartment: {
                name: '',
                description: '',
                entity_id: entityId,
                status: 1,
            },

            // Preselect
            selectedLastName: '',
            selectedJobTitle: '',
            selectedUnionJobTitle: '',
            // defaultLocation: '',
            // defaultLocationId: '',
            defaultCity: '',
            defaultState: '',
            newLocationState: '',
            selectedAgreement: '',

            currentOtRules: undefined,
            defaultCanadaVacationPay: 0.04,

            // helper to track changes for hidden fields
            changes: {
                assignment: [],
                employee: [],
            },
            lockedInclVac: false,

            rateFieldDisabled: false,

            unionLocalJobFilter: null,
            agreementJobFilter: null
        }
    },

    computed: {
        jobTitles() {
            if (parseInt(this.assignment.flsa_type_id) === 3) {
                if (this.assignment.union_local_id) {
                    return this.selectedUnionJobs;
                } else {
                    // Need to retrieve job IDs that match a specific local and then find those jobs.
                    return this.unionJobs;
                }
            } else {
                return this.allJobs;
            }
        },

        // Show Rule Collections appropriate for the given FLSA, Union, or legislative type
        filteredRules () {
            // Handle when no rule collections are loaded yet
            if (! Array.isArray(this.ruleCollections)) return [];

            // By default, available rules are ones that match the legislative type.
            // We can limit the display if the `allowedNonUnionRuleCollections` or `allowedUnionRuleCollections` are set in other_properties,
            // e.g. allowedNonUnionRuleCollections: [ 2, 9 ] will only show only rule collections 2 or 9
            const legislativeRules = this.ruleCollections.filter(({legislative_type_id}) => parseInt(legislative_type_id) === parseInt(this.assignment.legislative_type_id));
            if (!this.union && this.allowedNonUnionRuleCollections && Array.isArray(this.allowedNonUnionRuleCollections) && this.allowedNonUnionRuleCollections.length > 0) {
                const idealRules = this.ruleCollections.filter(({ id, legislative_type_id }) => this.allowedNonUnionRuleCollections.includes(parseInt(id)) && parseInt(legislative_type_id) === parseInt(this.assignment.legislative_type_id));
                // If no matches to ideal rules exist return all rules that match the legislative type
                return (idealRules || []).length ? idealRules : legislativeRules;
            } else if (this.union && this.allowedUnionRuleCollections && Array.isArray(this.allowedUnionRuleCollections) && this.allowedUnionRuleCollections.length > 0) {
                return this.ruleCollections.filter(({id}) => this.allowedUnionRuleCollections.includes(parseInt(id)));
            } else {
                return legislativeRules;
            }
        },

        unionLocalsFiltered () {
            // If hired from LA, must limit unions that have been explictly set to LA jurisdiction
            let list = undefined;
            let finalResult;
            if (this.union) {
                // Since a job is selected, look for specific matches
                if (this.assignment.union_local_id) {
                    list = [];
                    if (!this.locationFilterToggle && this.filteredUnionByLocation.length > 0) {
                        for (let unionLocalId of this.filteredUnionByLocation) {
                            const matchData = this.agreementLocals.filter((local) => parseInt(local.union_local_id) == unionLocalId);
                            if (matchData.length > 0) {
                                for (let unionData of matchData) {
                                    list.push(unionData);
                                }
                            }
                        }
                    } else {
                        list = this.agreementLocals;
                    }
                } else if (this.assignment.job_title_id) {
                    // Job matches
                    list = [];
                    const rulesets = [ ... new Set(this.unionJobRules.filter((ruleset) =>
                        (parseInt(ruleset.status) > 0) && 
                        (parseInt(ruleset.job_title_id) === parseInt(this.assignment.job_title_id)) &&
                        (this.assignment.union_local_id ? parseInt(ruleset.union_local_id) === parseInt(this.assignment.union_local_id) : true) &&
                        (this.assignment.agreement_id ? parseInt(ruleset.agreement_id) === parseInt(this.assignment.agreement_id) : true)
                    )) ];

                    // Find matching agreements and locals
                    for (const i in rulesets) {
                        const rs = rulesets[i];
                        if (typeof rs !== 'object') continue;
                        if (!this.locationFilterToggle) {
                            if (this.filteredUnionByLocation.indexOf(rs.union_local_id) == -1) {
                                continue;
                            }
                        }

                        // If Hired from LA, look for locals specific to LA as a priority over national agreements
                        if (parseInt(this.assignment.union_hired_from_id) === 79) {
                            const laLocal = this.agreementLocals.find((aL) => parseInt(aL.jurisdiction_id) === 1 && parseInt(aL.union_local_id) === parseInt(rs.union_local_id) && parseInt(aL.agreement_id) === parseInt(rs.agreement_id));
                            if (laLocal) {
                                list.push(laLocal);
                                // console.log('LA ' + rs.id + ' ' + rs.union_local_id + ' ' + this.unionLocals.find((loc) => loc.id === rs.union_local_id).name + ' ' + rs.agreement_id + ' ' + this.agreements.find((ag) => ag.id === rs.agreement_id).name)
                                continue;
                            }
                        }

                        // Add a non-LA local 
                        const allLocal = this.agreementLocals.find((aL) => parseInt(aL.union_local_id) === parseInt(rs.union_local_id) && parseInt(aL.agreement_id) === parseInt(rs.agreement_id));
                        if (allLocal) {
                            list.push(allLocal);
                            // console.log('All ' + rs.id + ' ' + rs.union_local_id + ' ' + this.unionLocals.find((loc) => loc.id === rs.union_local_id).name + ' ' + rs.agreement_id + ' ' + this.agreements.find((ag) => ag.id === rs.agreement_id).name)
                        } else {
                            // console.log('No match');
                        }
                    };

                // Show all locals if there is no job title
                } else {
                    list = [];
                    if (!this.locationFilterToggle && this.filteredUnionByLocation.length > 0) {
                        for (let unionLocalId of this.filteredUnionByLocation) {
                            const matchData = this.agreementLocals.filter((local) => parseInt(local.union_local_id) == unionLocalId);
                            if (matchData.length > 0) {
                                for (let unionData of matchData) {
                                    list.push(unionData);
                                }
                            }
                        }
                    } else {
                        list = this.agreementLocals;
                    }
                }
            }
            // console.log('list', list);

            let uniqueList = [ ... new Set(list) ];

            if (uniqueList.length > 0) {
                finalResult = uniqueList.sort((a,b) => {
                    if (a.union_local < b.union_local) return 1;
                    if (a.union_local > b.union_local) return -1;
                    if (a.union_local === b.union_local) return 0;
                });
            } else {
                finalResult = [];
            }

            // Set if one match
            if (uniqueList.length === 1) {
                
                // console.log(uniqueList[0]);
                this.assignment.union_local_id = uniqueList[0].union_local_id;
                setTimeout(() => { this.updateLocals() }, 200);
            }
            return finalResult;
        },

        unionSchedulesFiltered () {
            let list = undefined;
            if (this.union && this.assignment.agreement_id && this.assignment.union_local_id && this.assignment.job_title_id) {
                const rulesets = [ ... new Set(this.unionJobRules.filter((ruleset) => ruleset.agreement_id == this.assignment.agreement_id && ruleset.union_local_id == this.assignment.union_local_id && ruleset.job_title_id == this.assignment.job_title_id))].map((rule) => rule.schedule_id);
                list = this.unionSchedules.filter((unionSchedule) => rulesets.includes(unionSchedule.id));
            } else if (this.union && this.assignment.agreement_id && this.assignment.job_title_id) {
                let rulesets = this.unionJobRules.filter((ruleset) => (ruleset.agreement_id == this.assignment.agreement_id && ruleset.job_title_id == this.assignment.job_title_id)).map((rule) => rule.schedule_id)
                list = this.unionSchedules.filter((unionSchedule) => rulesets.includes(unionSchedule.id));
            } else if (this.union && this.assignment.union_local_id && this.assignment.job_title_id) {
                let rulesets = this.unionJobRules.filter((ruleset) => (ruleset.union_local_id == this.assignment.union_local_id && ruleset.job_title_id == this.assignment.job_title_id)).map((rule) => rule.schedule_id)
                list = this.unionSchedules.filter((unionSchedule) => rulesets.includes(unionSchedule.id));
            } else if (this.union && this.assignment.job_title_id) {
                let rulesets = this.unionJobRules.filter((ruleset) => (ruleset.job_title_id == this.assignment.job_title_id)).map((rule) => rule.schedule_id)
                list = this.unionSchedules.filter((unionSchedule) => rulesets.includes(unionSchedule.id));
            } else {
                list = this.unionSchedules;
            }

            if (list.length > 0) {
                // Set if one match
                if (list.length === 1) {
                    // console.log(list[0]);
                    this.assignment.union_schedule_id = list[0].id;
                    setTimeout(() => { this.updateUnionSchedule() }, 200);
                }
                return list;
            } else {
                return this.unionSchedules;
            }
        },

        unionOnProdFiltered () {
            let list = undefined;
            if (this.union && this.assignment.job_title_id) {
                let prods = this.unionJobRules.map(ruleset => (ruleset.job_title_id == this.assignment.job_title_id) ? ruleset.on_prod_id : null)
                list = this.unionOnProd.filter(onProd => prods.includes(onProd.id));
            } else {
                list = this.unionOnProd;
            }

            if (list.length > 0) {
                // Set if one match
                if (list.length === 1) {
                    // console.log(list[0]);
                    this.assignment.union_on_prod_id = list[0].id;
                    setTimeout(() => { this.updateUnionSchedule() }, 200);
                }
                return list;
            } else {
                return this.unionOnProd;
            }
        },

        mainLocation () {
            return this.projectLocations.find(({ id }) => parseInt(id) === parseInt(this.assignment.location_id)) || {};
        },

        customEmployerForms () {
            return this.customForms.filter(({fields}) => {
                let matches = (fields.find(field => {
                    if (field.role === 'employer') return true;
                })) ;
                if (matches) return true;
            });
        },

        customEmployeeForms () {
            return this.customForms.filter(({fields}) => {
                let matches = (fields.find(field => {
                    if (!field.role || field.role === 'employee') return true;
                })) ;
                if (matches) return true;
            });
        },

        mainLocationState () {
            return this.mainLocation.state || null;
        },

        isForeign() {
            return (parseInt(this.assignment.currency_id)) > 1 || (parseInt(this.employee.main_country_id)) > 1 || (parseInt(this.mainLocation.country_id)) > 1;
        },
        isCanada() {
            return (parseInt(this.assignment.currency_id)) === 2 || (parseInt(this.employee.main_country_id)) === 2 || (parseInt(this.mainLocation.country_id)) === 2;
        },
        isCanadianCurrency() {
            return parseInt(this.assignment.currency_id) === 2;
        },
        hasForeignLocations() {
            if (!this.projectLocations || !this.projectLocations.length) return false;
            const countries = [ ... new Set(this.projectLocations.filter((loc) => loc.country_id > 1)) ];
            return countries.length > 0;
        },
        isSsnNeeded() {
            return (parseInt(this.assignment.currency_id)) === 1 || (parseInt(this.employee.main_country_id)) === 1 || (this.employee.citizenship_id && (parseInt(this.employee.citizenship_id)) < 19);
        },
        showEEO() {
            return !this.isForeign || this.isSsnNeeded;
        },
        showSupervisorQuestion() {
            return this.harassmentCertification && (this.mainLocationState === 'CA' || this.companyHarassmentSupCertificateId);
        },
        defaultRateUnitPerDiem() {
            return this.defaultRateUnits.perDiem || 158;
        },
        defaultRateUnitLodging() {
            return this.defaultRateUnits.lodging || 158;
        },
        defaultRateUnitKit() {
            return this.defaultRateUnits.kitRental || 158;
        },
        defaultRateUnitCar() {
            return this.defaultRateUnits.carRental || 158;
        },
        defaultRateUnitPhone() {
            return this.defaultRateUnits.phone || 158;
        },

        currentUnionRuleset() {
            if (this.union && this.assignment.union_ruleset_id) {
                return this.unionJobRules.find((rule) => parseInt(rule.id) === parseInt(this.assignment.union_ruleset_id)) || {};
            } else {
                return {};
            }
        },

        currentStudioRuleCollection() {
            const rcId = parseInt(this.currentUnionRuleset.studio_rule_collection_id || 0);
            if (rcId) {
                return this.filteredRules.find((rc) => parseInt(rc.id) === rcId) || {}
            } else {
                return {};
            }
        },

        currentDistantRuleCollection() {
            const rcId = parseInt(this.currentUnionRuleset.distant_rule_collection_id || 0);
            if (rcId) {
                return this.filteredRules.find((rc) => parseInt(rc.id) === rcId) || {}
            } else {
                return {};
            }
        },

        currentBusToRuleCollection() {
            const rcId = parseInt(this.currentUnionRuleset.bus_rule_collection_id || 0);
            if (rcId) {
                return this.filteredRules.find((rc) => parseInt(rc.id) === rcId) || {}
            } else {
                return {};
            }
        },

        currentReportToRuleCollection() {
            const rcId = parseInt(this.currentUnionRuleset.report_rule_collection_id || 0);
            if (rcId) {
                return this.filteredRules.find((rc) => parseInt(rc.id) === rcId) || {}
            } else {
                return {};
            }
        },

        currentStudioDistantRuleCollection() {
            const rcId = parseInt(this.currentUnionRuleset.distant_studio_rule_collection_id || 0);
            if (rcId) {
                return this.filteredRules.find((rc) => parseInt(rc.id) === rcId) || {}
            } else {
                return {};
            }
        },

        width() {
            return '100%';
        },

        height() {
            return window.innerHeight * 0.35 + 'px';
        },

        isPaidScale() {
            return this.assignment.is_paid_scale === true || this.assignment.is_paid_scale === 1;
        },

        jobFilterOptions() {
            if (this.union && (this.unionLocalJobFilter || this.agreementJobFilter)) {
                return {
                    'rules__union_local': this.unionLocalJobFilter,
                    'rules__agreement': this.agreementJobFilter
                }
            }
            else {
                return {}
            }
        },

        totalAllowances() {
            const total =  
                parseFloat(this.assignment.kit_rental || '0') +
                parseFloat(this.assignment.kit_rental_tax || '0') +
                parseFloat(this.assignment.per_diem || '0') +
                parseFloat(this.assignment.per_diem_taxable || '0') +
                parseFloat(this.assignment.lodging || '0') +
                parseFloat(this.assignment.lodging_tax || '0') +
                parseFloat(this.assignment.phone_allow || '0') +
                parseFloat(this.assignment.per_diem_advance || '0') +
                parseFloat(this.assignment.car_rental || '0') +
                parseFloat(this.assignment.other || '0') +
                parseFloat(this.assignment.agent_fee || '0') +
                parseFloat(this.assignment.mileage || '0');
            return total;
        },

        capTotal() { 
            const total = 
                parseFloat(this.assignment.kr_cap || '0') +
                parseFloat(this.assignment.krtax_cap || '0') +
                parseFloat(this.assignment.cr_cap || '0') +
                parseFloat(this.assignment.phone_cap || '0');
            return total;
        },
    },

    methods: {
        addDisabledRateUnits(id) {
            if (! this.disabledRateUnits.includes(id)) this.disabledRateUnits.push(id);
        },

        removeDisabledRateUnits(id) {
            if (this.disabledRateUnits.includes(id)) this.disabledRateUnits.splice(this.disabledRateUnits.indexOf(id),1);
        },
        openMultiSelect() {
            this.$nextTick(() => {
                $('.multiselect .multiselect__content-wrapper').scrollTop(0);    // scroll to top of list 1st
                let idx = this.unionLocalsFiltered.findIndex((aLocal) => aLocal.agreement_id == this.assignment.agreement_id && aLocal.union_local_id == this.assignment.union_local_id);
                if (idx == -1) idx = 0;
                this.$refs.agreementLocal.pointer = idx;
                this.union_local_pointer = idx;
                if (idx != 0) {
                    const selectedtop = $('.multiselect .multiselect__content .multiselect__element .multiselect__option--selected').position().top;
                    $('.multiselect .multiselect__content-wrapper').scrollTop(selectedtop);
                }
            });
        },
        checkLocType(event, field) {
            if (this.union && event && event.target && event.target.value != 159) {
                if (field == 'pd' || field == 'pd_taxable') {
                    if (this.assignment.pd_loc_type) {
                        this.assignment.pd_loc_type = 0;
                        if (this.type == 'edit') ((this.$refs['assignment.pd_loc_type'] || {}).classList || {}).add('form-change');
                    }
                    if (this.assignment.pd_taxable_loc_type) {
                        this.assignment.pd_taxable_loc_type = 0;
                        if (this.type == 'edit') ((this.$refs['assignment.pd_taxable_loc_type'] || {}).classList || {}).add('form-change');
                    }
                } else if (field == 'lodging' || field == 'lodging_tax') {
                    if (this.assignment.lodging_loc_type) {
                        this.assignment.lodging_loc_type = 0;
                        if (this.type == 'edit') ((this.$refs['assignment.lodging_loc_type'] || {}).classList || {}).add('form-change');
                    }
                    if (this.assignment.lodging_tax_loc_type) {
                        this.assignment.lodging_tax_loc_type = 0;
                        if (this.type == 'edit') ((this.$refs['assignment.lodging_tax_loc_type'] || {}).classList || {}).add('form-change');
                    }
                } else if (this.assignment[field+'_loc_type']) {
                    this.assignment[field+'_loc_type'] = 0;
                    if (this.type == 'edit') ((this.$refs['assignment.'+field+'_loc_type'] || {}).classList || {}).add('form-change');
                }
                this.validateAllowanceLocType();
            }
        },
        validateAllowanceLocType() {
            this.allowanceMessage = false;
            if (this.assignment.union_location_id) {
                if (this.assignment.union_location_id == 152 || this.assignment.union_location_id == 155) {
                    // distant case
                    if (this.assignment.kr_loc_type == 1 || this.assignment.krtax_loc_type == 1 || this.assignment.phone_loc_type == 1 || this.assignment.pd_loc_type == 1 || this.assignment.pd_taxable_loc_type == 1 || this.assignment.lodging_loc_type == 1 || this.assignment.lodging_tax_loc_type == 1 || this.assignment.cr_loc_type == 1) {
                        // + Tax
                        this.allowanceMessage = true;
                    }
                } else {
                    // other case (Studio, Report to, Bus to)
                    if (this.assignment.kr_loc_type == 2 || this.assignment.krtax_loc_type == 2 || this.assignment.phone_loc_type == 2 || this.assignment.pd_loc_type == 2 || this.assignment.pd_taxable_loc_type == 2 || this.assignment.lodging_loc_type == 2 || this.assignment.lodging_tax_loc_type == 2 || this.assignment.cr_loc_type == 2) {
                        // + Tax
                        this.allowanceMessage = true;
                    }
                }
            }
        },
        async getFilteredUnionLocalsByLocation(work_location_id, hired_from_id, isChanged = false) {
            if (!work_location_id || !hired_from_id) {
                this.filteredUnionByLocation = [];
                return;
            }
            let workLocation = this.projectLocations.find((loc) => loc.id == work_location_id);
            if (!workLocation) {
                this.filteredUnionByLocation = [];
                return;
            }
            if (hired_from_id == 80) {
                let findState = this.allUnionHiredFrom.find((loc) => loc.code == workLocation.state);
                if (!findState) {
                    this.filteredUnionByLocation = [];
                    return;
                }
                hired_from_id = findState.id;
            }
            if (isChanged) {
                this.assignment.union_local_id = '';
                this.selectedAgreementLocal = '';
                this.assignment.job_title = '';
                this.assignment.job_title_id = '';
                this.assignment.job_title_override = '';
                this.assignment.occ_code = '';
                this.selectedJobTitle = '';
            }
            let hiredFromLocation = hired_from_id;        
            const responseFilteredUnionLocals = await this.oasisApi.get(`/unions/locations/${workLocation.state_id}/${hiredFromLocation}`)
            let filteredUnionLocalsByLocation = responseFilteredUnionLocals.data;
            this.filteredUnionByLocation = filteredUnionLocalsByLocation;
            return;
        },
        removedSelectedRow() {
            this.$refs.viewDept.removeSelectedRow();
        },
        // to get recent data for approvers on entity
        async getRecentAllApprover() {
            const responseAllApproverByEntity = await this.oasisV3Api.getAllPages(`/employer/approvers?entity_id=${entityId}`);
            this.allApproverByEntity = responseAllApproverByEntity.data.results;
            if (this.isWorkflowChanged) this.isWorkflowChanged = false;
        },
        getUserName(params) {
           return this.allUserbyEntity.get(params.value);
        },
        async closeEditDefaultModal() {
            if (this.isWorkflowChanged) this.getRecentAllApprover();
            this.defaultDeptModal = false;
        },
        // to detect whether department fields are changed or not
        isDeptChanged() {
            if (!this.deptChanged) this.deptChanged = true;
        },
        // save department first If user changed department and workflow
        saveDepartment() {
            if (!this.checkForm("#editDepartmentForm")) return;
            if (this.deptChanged) {
                return this.oasisApi.patch(`/departments/${this.selectedDepartment.id}`, this.selectedDepartment)
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            if (response.data.count === 1) {
                                return response.data.results;
                            }
                            else return false;
                        } else if (response.status == 400 || response.status == 422) {
                            if (Array.isArray(response.data.errorMessages)) {
                                const errorMessages = response.data.errorMessages;
                                let message = '';
                                for (const i in errorMessages) {
                                    if (typeof errorMessages[i].message !== 'string') continue;
                                    $("#addDepartmentForm input[name='" + errorMessages[i].field + "']").addClass('form-error2');
                                    message += (errorMessages[i].message + "\n") || '';
                                }
                                this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                            } else {
                                this.createDialog({ "title": "Error", "body": response.data.message || 'Error adding the field.', "buttonNo": false, "buttonYesLabel": "OK"  });
                            }
                            return false;
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data , "buttonNo": false, "buttonYesLabel": "OK" });
                            return false;
                        }
                    })
                    .then(result => {
                        if (!result) return false;
                        this.assignment.department = result[0].name;
                        this.assignment.department_id = result[0].id;
                        // Refresh
                        this.oasisApi.get('/departments')
                            .then(response => { if (response && response.data && response.data.results) this.departments = response.data.results; })
                            .catch(error => { console.log(error); });
                        this.deptChanged = false;
                        return true;
                    })
                    .catch(error => {
                        console.log('error: '); console.log(error); return false;
                    });
            } else {
                return true;
            }
        },
        isGridChanged(event) {
            if (this.deptApproverWorkflow == 1) {
                if (!this.gridChanged) this.gridChanged = true;
                /* there is no id in two cases - If there is no id, user did add and will be updated.
                    1. add case  
                    2. edit case that there is no any workflow */
                if (event.data.id) {
                    if (!this.changedRow.has(event.data.id)) {
                        this.changedRow.set(event.data.id,true);
                    }
                }
                this.$refs.viewDept.reDraw();
            }
        },
        async saveGrid() {
            // this function can be triggered by three modals - 1. adddepartment 2. editdepartment 3. defaultdepartment
            let modal;
            if (this.departmentModal) {
                modal = 'add';
                let addDept = await this.addDepartment();
                if (!addDept) return;
            } else if (this.defaultDeptModal) {
                modal = 'default';
            } else {
                modal = 'edit';
                let saveDept = await this.saveDepartment();
                if (!saveDept) return;
            }
            let errorMeg = '';
            if (this.gridChanged) {
                let count = 0;
                if (this.rowData.length < 1) this.rowData = JSON.parse(JSON.stringify(this.retrieveDefaultApprover));;
                for (let ele of this.rowData) {
                    count++;
                    if (!ele.user_id || (!ele.approver_group && ele.approver_type != 3)) {
                        errorMeg += 'Row' + count + ' - ' + "please resolved highlighted fields <br>";
                        continue;
                    }
                    let username = this.allUserbyEntity.get(ele.user_id);
                    // handle for default data.
                    if (!ele.department_id && !this.defaultDeptModal) {
                        ele.id = '';
                        ele.department_id = this.assignment.department_id;
                    }
                    if (ele.id) {
                        if (this.changedRow.has(ele.id)) {
                            // edit case
                            let response = await this.oasisV3Api.patch(`/employer/approvers/${ele.id}`, ele)
                            if (response && response.status == 200 || response.status == 201) {
                                if (!this.isWorkflowChanged) this.isWorkflowChanged = true;
                                this.changedRow.delete(ele.id);
                            } else if (Array.isArray(response.data.errorMessages)) {
                                const errorMessages = response.data.errorMessages;
                                for (const i in errorMessages) {
                                    if (typeof errorMessages[i].message !== 'string') continue;
                                    errorMeg += 'Row' + count + '(' + username + ')' + ' - ' + (errorMessages[i].message || '') + "<br>";
                                }
                            } else {
                                errorMeg += 'Row' + count + '(' + username + ')' + ' - ' + (response.data.message || response.data + "<br>");
                            }
                        }
                    } else {
                        // add case
                        let response = await this.oasisV3Api.post(`/employer/approvers/`, ele);
                        if (response && response.status == 200 || response.status == 201) {
                            // we should update Id in rowData after update to avoid duplicated updates
                            ele.id = response.data.id;
                            if (!this.isWorkflowChanged) this.isWorkflowChanged = true;
                        } else if (Array.isArray(response.data.errorMessages)) {
                            const errorMessages = response.data.errorMessages;
                            for (const i in errorMessages) {
                                if (typeof errorMessages[i].message !== 'string') continue;
                                errorMeg += 'Row' + count + '(' + username + ')' + ' - ' + (errorMessages[i].message || '') + "<br>";
                            }
                        } else {
                            errorMeg += 'Row' + count + '(' + username + ')' + ' - ' + (response.data.message || response.data + "<br>");
                        }
                    }
                }
                if (errorMeg) {
                    this.createDialog({ "title": "Warning", "body": errorMeg, "buttonNo": false, "buttonYesLabel": "OK"  });
                    return;
                }
            }
            if (modal == 'add') {
                this.closeDepartmentModal();
            } else if (modal == 'edit') {
                this.closeViewDepartmentModal();
            } else {
                this.closeEditDefaultModal();
            }
            this.gridChanged = false;
        },
        async addRow() {
            if (this.assignment.department_id === 'addDepartment') {
                let res = await this.addDepartment(false);
                if (!res) return;
            }
            // editDefault case - default department(no department)
            // otherwise, there is a department_id.
            let department_id = this.assignment.department_id === 'editDefault' ? null : this.assignment.department_id;
            let addNew = {user_id: null, approver_group: 1, approver_type: 0, department_id: department_id, status: 1, send_notifications: 1, final_approver: 0, entity_id: entityId};
            this.rowData = [...this.rowData, addNew];
            this.gridChanged = true;
        },
        async closeViewDepartmentModal() {
            if (this.isWorkflowChanged) this.getRecentAllApprover();
            this.isFirstEdit = false;
            this.viewDepartModal = false;
        },
        async openViewDepartModal() {
            // reset
            this.gridChanged = false; // for grid changes
            this.rowData = [];
            this.changedRow.clear();
            this.deptChanged = false; // for department

            this.selectedDepartment = this.departments.find((department) => department.id == this.assignment.department_id);
            // open existing department
            if (this.assignment.department_id && this.assignment.department_id != 'addDepartment') {
                this.retrieveApproverByDept = this.allApproverByEntity.filter((data) => data.department_id === this.assignment.department_id);
                // deep copy. because If user change some values, when  user cancel and re-open modal, DOM is already changed even though user didn't update (show wrong values).
                // another way is to use api call when user open modal each time.
                this.rowData = JSON.parse(JSON.stringify(this.retrieveApproverByDept));
            } 
            if (this.rowData.length < 1) {
                // existing department with no workflow.
                this.isFirstEdit = true;
                this.retrieveDefaultApprover = this.allApproverByEntity.filter((data) => data.department_id == null || data.department_id == undefined || data.department_id == '');
                this.rowData = JSON.parse(JSON.stringify(this.retrieveDefaultApprover));
            }
            this.iteration++;
            this.viewDepartModal = true;
        },
        viewPayRuleRequirements(type) {
            let link;
            if (type === 'non_union') {
                link = this.ruleCollections.find((rule) => rule.id == this.assignment.rule_collection_id);
            } else if (this.assignment.union_rule_overrides && this.assignment.union_rule_overrides[type]) {
                link = this.ruleCollections.find((rule) => rule.id == this.assignment.union_rule_overrides[type]);
            } else if (type === 'studio') {
                link = this.currentStudioRuleCollection;
            } else if (type === 'distant') {
                link = this.currentDistantRuleCollection;
            } else if (type === 'reportto') {
                link = this.currentReportToRuleCollection;
            } else if (type === 'busto') {
                link = this.currentBusToRuleCollection;
            } else if (type === 'studiodistant') {
                link = this.currentStudioDistantRuleCollection;
            }
            
            if (link && link.ext_reqs_url) {
                window.open(link.ext_reqs_url, "_blank");
            } else {
                this.createDialog({ "title": "Warning", "body": 'No Pay Rule Requirements Available. Please notify the ProHire Team.<br />', "buttonNo": false, "buttonYesLabel": "OK"  });
            }
        },
        addressAutoComplete(address, section) {
            if (typeof(address) === 'object') {
                let state = this.states.find((element) => element.code == address.address.prov);
                let stateId;
                if (state) stateId = state.id;
                else stateId = 66;
                let countryId = address.address.country.toUpperCase() == 'US' ? 1 : 2;
                if (section === 'newLocation') {
                    let removedZip4 = address.address.pc.split("-");
                    this.newLocation.address1 = address.address.address;
                    this.newLocation.city = address.address.city;
                    this.newLocation.state_id = stateId;
                    this.newLocation.country_id = countryId;
                    this.newLocation.postal = removedZip4[0];
                }
            } else {
                if (section === 'newLocation') {
                    this.newLocation.address1 = address;
                }
            }
        },
        // to check address validate or not
        async checkAddressForm() {
            let newLocationRes = true;

            // have error, return false
            if (this.error_newLocation_generic) newLocationRes = false;

            // reset
            if (this.isNewLocationUpdated) this.isNewLocationUpdated = false;

            /* validation function will be ran below conditions
               1. A certain field was changed in address form
               2. US and Canada
               3. no error
               4. not address override
            */
            if (this.isNewLocationAddressChanged && this.newLocation.state_id != 66 && newLocationRes && !this.isNewLocationOverride && this.newLocation.address1) {
                newLocationRes = await this.verifyFields(this.newLocation.address1, this.newLocation.address2, this.newLocation.city, this.newLocation.state_id, this.newLocation.postal, this.newLocation.country_id, 'newLocation');
                if (newLocationRes) this.isNewLocationAddressChanged = false;
            }

            if (newLocationRes) {
                return true;
            } else {
                this.createDialog({ "title": "Warning", "body": 'Please check address fields before submitting.<br />', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            }
        },
        // address override
        overrideAddress(section) {
            if (section === 'newLocation') {
                this.removeErrorMessage('newLocation');
                this.isNewLocationOverride = true;
                this.isNewLocationUpdated = false;
            }
        },
        newLocationAddressChange() {
            // remove error existing message and changed true
            if (!this.isNewLocationAddressChanged) this.isNewLocationAddressChanged = true;
            this.removeErrorMessage('newLocation')
        },
        removeErrorMessage(section) {
            if (section === 'newLocation') {
                if (this.error_newLocation_generic) this.error_newLocation_generic = '';
                if (this.error_newLocation_address1) this.error_newLocation_address1 = '';
                if (this.error_newLocation_city) this.error_newLocation_city = '';
                if (this.error_newLocation_postal) this.error_newLocation_postal = '';
                if (this.error_newLocation_state) this.error_newLocation_state = '';
            }
        },
        verify(address1, address2, city, state, postal, country) {
            // actual verification function

            return new Promise(function (resolve, reject) {
                if (address1.length === 0) {
                    return;
                }
    
                let address = {
                    line1: address1
                };
                if (address2) {
                    address.line2 = address2;
                }
                if (city) {
                    address.city = city;
                }
                if (state) {
                    address.provinceOrState = state;
                }
                if (postal) {
                    address.postalOrZip = postal;
                }
                if (country) {
                    address.country = country;
                }
                var xhr = new XMLHttpRequest();
                xhr.open(
                    'POST',
                    'https://api.postgrid.com/v1/addver/verifications?includeDetails=true',
                );
                xhr.setRequestHeader('Content-Type', 'application/json');
                if (postGridKey) {
                    xhr.setRequestHeader('X-API-KEY', postGridKey);
                }
                xhr.timeout = 15000;
                xhr.onload = function () {
                    var resp = JSON.parse(xhr.responseText);
                    if (xhr.status === 200) {
                        resolve(resp.data);
                    } else {
                        reject(resp);
                    }
                };
                // late response
                xhr.ontimeout = function (e) {
                    reject();
                };
                xhr.send(JSON.stringify({ address }));
            });
        },
        async verifyFields(address1, address2, city, state, postal, country, section) {
            if (!address1) {
                return false;
            }
            // we want to separate suite number and key into line 2
            // postgrid provide line 1 with suite number and key
            let line2CustomString = '';
            
            try {
                if (state) state = this.states.find((element) => element.id == state).code;
                if (country) country = country == 1 ? 'US' : 'CA';

                let result = await this.verify(address1, address2, city, state, postal, country);
                if (result.line1) address1 = result.line1;

                if (result.zipPlus4) {
                    result.postalOrZip = result.postalOrZip
                        ? result.postalOrZip + '-' + result.zipPlus4
                        : result.zipPlus4;
                }
                if (result.urbanization) {
                    result.line2 = result.line2
                        ? result.line2 + ' URB ' + result.urbanization
                        : result.urbanization;
                }
                address2 = result.line2 ? result.line2 : '';
                if (result.details.suiteKey && result.details.suiteID) {
                    if (country == 1 || country.toUpperCase() == 'US') {
                        address1 = address1.split(result.details.suiteKey)[0];
                        line2CustomString = result.line2 ? result.line2 + ' ' + result.details.suiteKey + ' ' + result.details.suiteID : result.details.suiteKey + ' ' + result.details.suiteID;
                        address2 = line2CustomString;
                    }
                }
                if (result.city) city = result.city;
                if (result.provinceOrState) {
                    state = this.states.find((element) => element.code == result.provinceOrState.toUpperCase());
                    if (!state) result.status = 'falied';
                    else state = state.id;
                }
                if (result.postalOrZip) postal = result.postalOrZip;
                if (result.country) {
                    country = result.country.toUpperCase() == 'US' ? 1 : 2;
                }
                
                if (result.status === 'verified' || result.status === 'corrected') {
                    // insert data
                    if (section === 'newLocation') {
                        this.newLocation.address1 = address1;
                        this.newLocation.address2 = address2;
                        this.newLocation.city = city;
                        this.newLocation.state_id = state;
                        this.newLocation.country_id = country;
                        this.newLocation.postal = postal;
                        if (result.status === 'corrected') this.isNewLocationUpdated = true;
                    }
                    return true;
                } else {
                    if (result.errors) {
                        // handle errors
                        if (section === 'newLocation') {
                            if (result.errors.line1) this.error_newLocation_address1 = result.errors.line1;
                            if (result.errors.city) this.error_newLocatioin_city = result.errors.city;
                            if (result.errors.provinceOrState) this.error_newLocatioin_state = result.errors.provinceOrState;
                            if (result.errors.postalOrZip) this.error_newLocation_postal = result.errors.postalOrZip;
                            this.error_newLocation_generic = 'Address may not be valid';
                        }
                    }
                    return false;
                }
            } catch (err) {
                if (section === 'newLocation') this.error_newLocation_generic = 'Address may not be valid';
                return false;
            }
        },
        newStart() {
            const scope = this;
            if (this.modified) {
                this.createDialog({ "title": "Are You Sure?", "body": "You will lose your work.  Proceed?",
                    "buttonYesAction": function () { scope.resetStart() },
                });
            } else {
                this.resetStart();
            }
        },

        resetStart() {
            this.selectedJobTitle = '';
            this.selected_budget_code = '';
            this.selected_fringe_code = '';
            this.selected_free_field = '';
            this.selected_free_field2 = '';
            this.selected_series_code = '';
            this.selected_location_code = '';
            this.selected_set_code = '';
            this.selected_pw_budget_code = '';
            this.selected_pw_fringe_code = '';
            this.selected_pw_free_field = '';
            this.selected_pw_free_field2 = '';
            this.selected_pw_series_code = '';
            this.selected_pw_location_code = '';
            this.selected_pw_set_code = '';
            this.selected_kr_code = '';
            this.selected_kr_free_field = '';
            this.selected_kr_free_field2 = '';
            this.selected_krtax_code = '';
            this.selected_krtax_free_field = '';
            this.selected_krtax_free_field2 = '';
            this.selected_pd_code = '';
            this.selected_pd_free_field = '';
            this.selected_pd_free_field2 = '';
            this.selected_pd_taxable_code = '';
            this.selected_pdtax_free_field = '';
            this.selected_pdtax_free_field2 = '';
            this.selected_lodging_code = '';
            this.selected_lodging_free_field = '';
            this.selected_lodging_free_field2 = '';
            this.selected_lodging_tax_code = '';
            this.selected_lodging_tax_free_field = '';
            this.selected_lodging_tax_free_field2 = '';
            this.selected_phone_allow_code = '';
            this.selected_phone_allow_free_field = '';
            this.selected_phone_allow_free_field2 = '';
            this.selected_cr_code = '';
            this.selected_cr_free_field = '';
            this.selected_cr_free_field2 = '';
            this.selectedUnionJobTitle = '';
            this.defaultCity = '';
            this.defaultState = '';
            this.newLocationState = '';
            this.scale = null;
            this.scaleMessage = '';
            this.minWage = {};
            this.selectedLastName = '';
            this.selectedAgreement = '';
            this.selected_agent_code = '';
            this.selected_agent_free_field = '';
            this.selected_agent_free_field2 = '';
            this.resetJobInfoToggle = true;
            // this.customForms = customForms;
            // this.selectedCustomForms = [];

            this.locationModal = false; // Show the add location modal?
            this.departmentModal = false; // Show the add department modal?
            this.empLocked = false; // make the employee read only?
            this.empSet = false; // make the employee read only?
            this.rateUnitLocked = false;
            this.guaranteedUnitLocked = false;
            this.minimumGuarantee = 0;
            this.modified = false;
            this.startCalendar = false;
            this.existingStart = false;
            this.union = false;
            this.local = '';
            this.noUnionJobMatch = false;

            // Reset Employee
            this.employee.id =  '';
            this.employee.last_name =  '';
            this.employee.first_name =  '';
            this.employee.email =  '';
            this.employee.tin =  '';
            this.employee.foreign_tin =  '';
            this.employee.special_type =  '';
            this.employee.show_agent = '';
            this.employee.special_type_properties = undefined;
            this.employee.main_state_id = '';
            this.employee.metadata = {};

            // Reset some Assignment details
            this.assignment.id = '';
            this.assignment.is_paid_scale = false;
            this.assignment.rate = '';
            this.assignment.rate_unit_id = '';
            this.assignment.guaranteed_hours = '';
            this.assignment.guaranteed_hours_unit_id = '8';
            this.assignment.guaranteed_hours_6th = '';
            this.assignment.guaranteed_hours_7th = '';
            this.assignment.pd_rate_unit_id = '',
            this.assignment.lodging_rate_unit_id = '',
            this.assignment.kit_rate_unit_id = '',
            this.assignment.phone_rate_unit_id = '',
            this.assignment.car_rate_unit_id = '',
            this.assignment.hourly_rate = '';
            this.assignment.scale_rate = null;
            this.assignment.scale_stn = null;
            this.assignment.rate_comment = '';
            this.assignment.job_order = 1;
            this.assignment.job_title = '';
            this.assignment.job_title_id = '';
            this.assignment.job_title_override = '';
            this.assignment.occ_code = '';
            this.assignment.flsa_type_id = 1;
            this.assignment.legislative_type_id = '';
            this.assignment.loanout_status = 0,
            this.assignment.rule_collection_id = '';
            this.assignment.aca_status_id = '';
            this.assignment.employee = '';
            this.assignment.employee_id = '';
            this.assignment.fringe_code = '';
            this.assignment.budget_code = '';
            this.assignment.free_field = '';
            this.assignment.free_field2 = '';
            this.assignment.location_code = '';
            this.assignment.series_code = '';
            this.assignment.set_code = '';
            this.assignment.pw_fringe_code = '';
            this.assignment.pw_budget_code = '';
            this.assignment.pw_free_field = '';
            this.assignment.pw_free_field2 = '';
            this.assignment.pw_location_code = '';
            this.assignment.pw_series_code = '';
            this.assignment.pw_set_code = '';
            this.assignment.kit_rental = '';
            this.assignment.kit_rental_tax = '';
            this.assignment.per_diem = '';
            this.assignment.per_diem_taxable = '';
            this.assignment.lodging = '';
            this.assignment.lodging_tax = '';
            this.assignment.phone_allow = '';
            this.assignment.per_diem_advance = '';
            this.assignment.car_rental = '';
            this.assignment.other = '';
            this.assignment.agent_fee = '';
            this.assignment.mileage = '';
            this.assignment.mileage_rate = '';
            this.assignment.status = '';
            this.assignment.kr_code = '';
            this.assignment.krtax_code = '';
            this.assignment.pd_code = '';
            this.assignment.pd_taxable_code = '';
            this.assignment.lodging_code = '';
            this.assignment.lodging_tax_code = '';
            this.assignment.phone_allow_code = '';
            this.assignment.pd_advance_code = '';
            this.assignment.cr_code = '';
            this.assignment.mi_code = '';
            this.assignment.other_code = '';
            this.assignment.agent_code = '';
            this.assignment.kr_free_field = '';
            this.assignment.krtax_free_field = '';
            this.assignment.pd_free_field = '';
            this.assignment.pdtax_free_field = '';
            this.assignment.lodging_free_field = '';
            this.assignment.lodging_tax_free_field = '';
            this.assignment.phone_allow_free_field = '';
            this.assignment.pdadv_free_field = '';
            this.assignment.cr_free_field = '';
            this.assignment.mi_free_field = '';
            this.assignment.other_free_field = '';
            this.assignment.agent_free_field = '';
            this.assignment.kr_free_field2 = '';
            this.assignment.krtax_free_field2 = '';
            this.assignment.pd_free_field2 = '';
            this.assignment.pdtax_free_field2 = '';
            this.assignment.lodging_free_field2 = '';
            this.assignment.lodging_tax_free_field2 = '';
            this.assignment.phone_allow_free_field2 = '';
            this.assignment.pdadv_free_field2 = '';
            this.assignment.cr_free_field2 = '';
            this.assignment.mi_free_field2 = '';
            this.assignment.other_free_field2 = '';
            this.assignment.agent_free_field2 = '';
            this.assignment.kr_cap = '',
            this.assignment.krtax_cap = '',
            this.assignment.cr_cap = '',
            this.assignment.phone_cap = '',
            this.assignment.occ_code = '';
            this.assignment.agreement = '';
            this.assignment.agreement_id = '';
            this.assignment.resident_state = '';
            this.assignment.resident_state_id = '';
            this.assignment.union_local = '';
            this.assignment.union_local_id = '';
            this.assignment.union_ruleset_id = '';
            this.assignment.union_flsa_type_id = '';
            this.assignment.custom_forms = {};
            this.assignment.custom_form_fields = {};
            this.assignment.custom_form_employer_fields = {};
            this.assignment.employer_comments = '';
            this.assignment.recurring_comments = '';
            this.assignment.union_hired_from_id = '';
            this.assignment.union_schedule_id = '';
            this.assignment.union_location_id = '';
            this.assignment.union_on_prod_id = '';
            this.assignment.union_rule_overrides = { studio: null, distant: null, busto: null, reportto: null, studiodistant: null};
            this.assignment.is_rehire = null;
            this.assignment.i9_verifier_id = null;
            this.assignment.i9_verified_date = null;
            this.assignment.list_a_type_id = null;
            this.assignment.list_a_auth = null;
            this.assignment.list_a_number = null;
            this.assignment.list_a_exp = null;
            this.assignment.list_b_type_id = null;
            this.assignment.list_b_auth = null;
            this.assignment.list_b_number = null;
            this.assignment.list_b_exp = null;
            this.assignment.list_c_type_id = null;
            this.assignment.list_c_auth = null;
            this.assignment.list_c_number = null;
            this.assignment.list_c_exp = null;
            this.assignment.ee_list_a_type_id = null;
            this.assignment.ee_list_a_auth = null;
            this.assignment.ee_list_a_number = null;
            this.assignment.ee_list_a_exp = null;
            this.assignment.ee_list_b_type_id = null;
            this.assignment.ee_list_b_auth = null;
            this.assignment.ee_list_b_number = null;
            this.assignment.ee_list_b_exp = null;
            this.assignment.ee_list_c_type_id = null;
            this.assignment.ee_list_c_auth = null;
            this.assignment.ee_list_c_number = null;
            this.assignment.ee_list_c_exp = null;
            this.assignment.is_supervisor = null;
            this.assignment.certification_type_id = null;
            this.assignment.metadata = {};
            this.assignment.kr_loc_type = 0;
            this.assignment.krtax_loc_type = 0;
            this.assignment.phone_loc_type = 0;
            this.assignment.pd_loc_type = 0;
            this.assignment.pd_taxable_loc_type = 0;
            this.assignment.lodging_loc_type = 0;
            this.assignment.lodging_tax_loc_type = 0;
            this.assignment.cr_loc_type = 0;
            this.employerMessage = '';
            this.editingCompletedStart = false;

            this.waiting = true;
            this.setDefaults();
            this.populateCustomForms();
            $("input[name='last_name']").focus();
            this.waiting = false;

            this.rateFieldDisabled = false;
        },

        // Retreive employee data based on an assignment under that entity (and its parents).
        getEmployee(value) {
            // Is this from autocomplete?  If so, the value should be the assignment id lookup the employee
            if (value.employee_id) {
                const assignment = Object.assign({}, value);
                this.oasisApi.get('/employees/' + assignment.employee_id)
                    .then(response => {
                        let employee = response.data;
                        this.employee.id = employee.id;
                        this.employee.last_name = (employee.last_name) ? employee.last_name : '';
                        this.employee.first_name = (employee.first_name) ? employee.first_name : '';
                        this.employee.email = (employee.email) ? employee.email : '';
                        this.employee.main_state_id = (employee.main_state_id) ? employee.main_state_id : '';
                        this.employee.tin = (employee.tin) ? employee.tin : '';
                        this.employee.foreign_tin = (employee.foreign_tin) ? employee.foreign_tin : '';
                        // this.employee.loanout_status = (employee.loanout_status) ? employee.loanout_status : '';
                        this.employee.special_type = (employee.special_type) ? employee.special_type : '';
                        this.employee.special_type_properties = (employee.special_type_properties) ? Object.assign({}, employee.special_type_properties) : {};
                        this.employee.show_agent = (employee.show_agent) ? employee.show_agent : '';
                        this.employee.metadata = (employee.metadata) ? Object.assign({}, employee.metadata) : {};

                        // Don't load start info if on the create page
                        if (typeof(availableAssignments) !== 'undefined' && assignment.entity_id == entityId) {
                            // Should be here only on edit page
                            // Make read only if employee has already approved
                            this.existingStart = true;
                            if (parseInt (assignment.employee_status) > 1 || parseInt (assignment.status) >= 4) {
                                this.empLocked = true;
                            } else {
                                this.empLocked = false;
                            }
                            this.updateAssignment (assignment);
                        // And Check to see if the entities match.  If not, it's a new start with an existing employee.
                        } else if (assignment.entity_id == entityId && assignment.hash) {
                            // Create page bringing up an employee
                            this.modified = false;
                            this.createDialog({ "title": "Warning", "body": 'There is an existing start for this employee.  Select "Edit" to modify the existing start or "Create New Start" for this employee.',
                                "buttonYesLabel": "Edit", "buttonYesAction": () => { this.waiting = true; window.location.href = '/oasis/starts/edit/' + assignment.hash; },
                                "buttonNoLabel": 'Create New Start',
                                "buttonNo": true,
                                "button3Label": 'Cancel',
                                "button3Action": () => { app.resetStart(); },
                                "button3": true,
                            });
                            this.existingStart = true;
                        } else {
                            // Load I9 info if not expired.
                            if (assignment.i9_verifier_id) {
                                this.loadI9(assignment); 
                            }
                        }
                    })
                    .catch(error => { console.log(error); })
                    .finally(() => {
                        this.empSet = true;
                        this.waiting = false;
                    }
                );

            // If not an assignment, new employee typed in
            } else {
                this.employee.last_name = value;
            }
        },

        checkUnion() {
            if (parseInt (this.assignment.legislative_type_id) === 4) {
                this.union = true;
            } else {
                this.union = false;
                this.assignment.union_ruleset_id = '';
                this.assignment.union_local_id = '';
                this.assignment.agreement_id = '';
                this.selectedAgreementLocal = '';
                this.assignment.union_flsa_type_id = '',
                this.assignment.union_schedule_id = '';
                this.assignment.union_location_id = 151;
                this.assignment.union_on_prod_id = '';
                this.assignment.union_rule_overrides = { studio: null, distant: null, busto: null, reportto: null, studiodistant: null};
                this.assignment.scale_rate = null;
                this.assignment.scale_stn = null;
                this.scale = null;
                this.scaleType = '';

                this.changes.assignment.push('union_ruleset_id');
                this.changes.assignment.push('union_local_id');
                this.changes.assignment.push('agreement_id');
                this.changes.assignment.push('union_flsa_type_id');
                this.changes.assignment.push('union_schedule_id');
                this.changes.assignment.push('union_location_id');
                this.changes.assignment.push('union_on_prod_id');
                this.changes.assignment.push('union_rule_overrides');
                this.changes.assignment.push('scale_rate');
                this.changes.assignment.push('scale_stn');
            }
        },

        checkRuleCollections() {
            let defaultRuleId = this.entity.default_overtime_id || 1;
            let currentOvertimeId = this.assignment.rule_collection_id;

            if (this.union === true || this.assignment.union_local_id) {
                // Do nothing as we are setting this in the union section

            // Only one match, set it automatically
            } else if (this.filteredRules.length === 1) {
                this.assignment.rule_collection_id = this.filteredRules[0].id;

            // Set it the same as before if something changed and the rule is still applicable
            } else if (currentOvertimeId && this.filteredRules.find(rule => rule.id == currentOvertimeId)) {
                this.assignment.rule_collection_id = currentOvertimeId;

            // Check defaults now
            } else if (defaultRuleId && this.filteredRules.find(rule => rule.id == defaultRuleId)) {
                this.assignment.rule_collection_id = defaultRuleId;

            // CA should always default to CA for CA jobs if not set above
            } else if (this.mainLocationState === 'CA' || parseInt(this.assignment.resident_state_id) === 5) {
                this.assignment.rule_collection_id = this.filteredRules && this.filteredRules.length ? this.filteredRules[0].id : '2';

            // Exempt
            } else if (this.assignment.flsa_type_id == 2) {
                this.assignment.rule_collection_id = '3';

            // No rules match current settings
            // Shouldn't be here, but set defaults
            } else if (this.filteredRules.length === 0) {
                this.assignment.rule_collection_id = currentOvertimeId || defaultRuleId;

            } else {
                // More than one rule.  Just choose first one...
                this.assignment.rule_collection_id = this.filteredRules[0].id || currentOvertimeId || defaultRuleId;
            }
        },

        // Autocomplete for Job Title
        async updateJobTitle(title) {
            if (title) {
                this.selectedJobTitle = title.name;
                this.assignment.job_title = title.name;
                this.assignment.job_title_override = title.name;
                this.assignment.job_title_id = title.id;
            } else if (!title) {
                // this case may be the case that use remove job title (set blank).
                this.selectedJobTitle = null;
                this.assignment.job_title = null;
                this.assignment.job_title_override = null;
                this.assignment.job_title_id = null;
                this.assignment.occ_code = null; // we should add this. bc If there is no job title, old occ code will be remaining.
            }

            // Union work here
            if (this.union === true) {
                if (this.unionSchedulesFiltered.length === 1) this.assignment.union_schedule_id = this.unionSchedulesFiltered[0].id;
                else this.assignment.union_schedule_id = undefined;

                if (this.unionOnProdFiltered.length === 1) this.assignment.union_on_prod_id = this.unionOnProdFiltered[0].id;
                else this.assignment.union_on_prod_id = undefined;

                if (!this.assignment.union_local_id) {
                    if (this.unionLocalsFiltered.length === 1) {
                        this.assignment.union_local_id = this.unionLocalsFiltered[0].union_local_id;
                        this.assignment.agreement_id = this.unionLocalsFiltered[0].agreement_id;
                        // this.$refs['assignment.union_local_id'].value = this.unionLocalsFiltered[0].id
                    } else {
                        this.assignment.union_local_id = undefined;
                        this.assignment.agreement_id = undefined;
                        this.resetJobInfoToggle = false;
                    }
                }

                this.assignment.union_rule_overrides = { studio: null, distant: null, busto: null, reportto: null, studiodistant: null};
                this.assignment.guaranteed_hours = undefined;
                this.assignment.guaranteed_hours_unit_id = undefined;

                // Set Occ code if we can
                await this.getUnionOccCode(this.assignment);
                await this.updateUnionSchedule();

            } else {
                // console.log('not union');
                this.assignment.union_local_id = this.assignment.agreement_id = this.assignment.union_ruleset_id = this.assignment.union_schedule_id = this.assignment.union_on_prod_id = this.assignment.union_flsa_type_id = this.assignment.occ_code = null;
                this.assignment.union_rule_overrides = { studio: null, distant: null, busto: null, reportto: null, studiodistant: null};

                // If there is a specific rule to a job (non-union)
                if (title.rule_collection_id) this.assignment.rule_collection_id = title.rule_collection_id;
            }

            // Update EEOC Job Category
            if (title.fed_jobcategory_id) {
                this.assignment.fed_jobcategory_id = title.fed_jobcategory_id;
            }
            if (title.ca_jobcategory_id) {
                this.assignment.ca_jobcategory_id = title.ca_jobcategory_id;
            }

            // Refresh custom forms
            this.populateCustomForms();

            // Force changes to be shown
            if (this.existingStart === true) {
                $("input[name='job_title']").addClass('form-change')
                $("input[name='job_title_override']").addClass('form-change')
            }
            
            // For union crew, show the scale at this point, if any, but not any errors for min wage as rates are not yet set.
            if(this.union) {
                this.loadScaleOnly();
            }
        },

        // Get Union Occ Code and set it
        async getUnionOccCode(assignment) {
            if (!assignment) assignment = this.assignment;
            if (!assignment.agreement_id || !assignment.union_local_id || !assignment.job_title_id) return '';
            let response = await this.oasisApi.get(`/unionOccCodes?agreement_id=${assignment.agreement_id}&union_local_id=${assignment.union_local_id}&job_title_id=${assignment.job_title_id}`);

            if (response && response.data && response.data.count) {
                let occ_code = response.data.results[0].code;
                this.assignment.occ_code = occ_code;
            } else {
                this.assignment.occ_code = '';
            }
        },

        changedHiredFrom() {
            if (!this.union) this.updateLocationSettings();
            if (this.union) {
                this.getFilteredUnionLocalsByLocation(this.assignment.location_id, this.assignment.union_hired_from_id, true);
                this.updateUnionSchedule();
            }
        },

        // Update Rule Collection to the best match
        async updateUnionSchedule() {
            // If not union or no job title is selected, ignore for now
            if (! this.union || ! this.assignment.job_title_id) { return false; }
            // Need to compute a few things first
            const job_title_id = this.assignment.job_title_id ? parseInt(this.assignment.job_title_id) : null;
            const agreement_id = this.assignment.agreement_id ? parseInt(this.assignment.agreement_id) : null;
            const union_local_id = this.assignment.union_local_id ? parseInt(this.assignment.union_local_id) : null;
            const union_schedule_id = this.assignment.union_schedule_id ? parseInt(this.assignment.union_schedule_id) : null;
            const union_location_id = this.assignment.union_location_id ? parseInt(this.assignment.union_location_id) : null;
            const union_on_prod_id = this.assignment.union_on_prod_id ? parseInt(this.assignment.union_on_prod_id) : null;
            const union_hired_from_id = this.assignment.union_hired_from_id ? parseInt(this.assignment.union_hired_from_id) : null;
            const union_jurisdiction_id = union_hired_from_id == 79 ? 1 : (this.mainLocation.union_jurisdiction_id ? parseInt(this.mainLocation.union_jurisdiction_id) : null);

            // we can't use existing way to multiselect (using refs).
            let element = document.getElementById("agreementLocal");
            // If fields are missing, highlight and exit
            if (!union_local_id) element.classList.add("form-missing");
            else element.classList.remove("form-missing");
            if (!union_schedule_id) ((this.$refs['assignment.union_schedule_id'] || {}).classList || {}).add('form-missing');
            else ((this.$refs['assignment.union_schedule_id'] || {}).classList || {}).remove('form-missing');

            if (!union_location_id) ((this.$refs['assignment.union_location_id'] || {}).classList || {}).add('form-missing');
            else ((this.$refs['assignment.union_location_id'] || {}).classList || {}).remove('form-missing');

            if (!union_on_prod_id) ((this.$refs['assignment.union_on_prod_id'] || {}).classList || {}).add('form-missing');
            else ((this.$refs['assignment.union_on_prod_id'] || {}).classList || {}).remove('form-missing');

            if (! union_hired_from_id) ((this.$refs['assignment.union_hired_from_id'] || {}).classList || {}).add('form-missing');
            else ((this.$refs['assignment.union_hired_from_id'] || {}).classList || {}).remove('form-missing');

            if (!union_local_id || !union_schedule_id || !union_location_id || !union_on_prod_id) { return false; }

            // Don't need to select rule collections if this is a loaded start
            // Just need to load the data we need for validation
            if (this.type === 'edit' && !this.modified) {
                this.unionJobRuleMx = this.unionJobRules.find((rule) => rule.id === this.assignment.union_ruleset_id);
                if (this.unionJobRuleMx.minimum_call_hours) {
                    this.minimumGuarantee = this.unionJobRuleMx.minimum_call_hours;
                }
                return true;
            }

            // Find the best ruleset matche(s)
            const rules = this.findBestUjmxRules(job_title_id, agreement_id, union_local_id, union_schedule_id, union_on_prod_id, union_jurisdiction_id);
            if (rules && rules.length) {
                this.unionJobRuleMx = rules[0]
            }

            // If we have all the pieces, and there's a matching rule set, let's fill in the blanks and lock it.
            const schedule = this.unionSchedulesFiltered.find(line => parseInt(line.id) === parseInt(this.assignment.union_schedule_id));
            this.assignment.union_ruleset_id = this.unionJobRuleMx.id;
            this.assignment.rule_collection_id = null;

            if (schedule && schedule.rate_unit_id) {
                // Exempt...
                // const exempt = schedule.flsa_type_id == 2 ? true : false;
                // console.log(schedule);

                this.minimumGuarantee = this.unionJobRuleMx.minimum_call_hours;
                this.assignment.union_flsa_type_id = schedule.flsa_type_id;
                this.assignment.rate_unit_id = this.assignment.rate_unit_id || schedule.rate_unit_id;
                this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.minimumGuarantee || '';
                this.assignment.guaranteed_hours_unit_id = schedule.guaranteed_unit_id;
                this.guaranteedUnitLocked = true;
                if (schedule.rate_unit_id == 3) {
                    this.assignment.rate_unit_id = schedule.rate_unit_id;
                    this.rateUnitLocked = true;
                } else if (schedule.rate_unit_id == 36) {
                    this.assignment.rate_unit_id = schedule.rate_unit_id;
                    this.rateUnitLocked = true;
                } else {
                    this.rateUnitLocked = false;
                }
            } else {
                // console.log('No schedule');
                this.minimumGuarantee = 0;
                this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || '';
                this.assignment.union_flsa_type_id = '';
                this.guaranteedUnitLocked = false;
                this.rateUnitLocked = false;
            }

            // Now set rule_collection if all done
            // Studio
            if (union_location_id === 151) {
                this.assignment.rule_collection_id = this.unionJobRuleMx.studio_rule_collection_id;
                this.assignment.guaranteed_hours = this.unionJobRuleMx.minimum_call_hours || this.assignment.guaranteed_hours;
                this.scaleType = 'studio';
            // Distant
            } else if (union_location_id === 152) {
                this.assignment.rule_collection_id = this.unionJobRuleMx.distant_rule_collection_id;
                this.assignment.guaranteed_hours = this.unionJobRuleMx.distant_minimum_call_hours || this.assignment.guaranteed_hours;
                this.scaleType = 'distant';
            // Report to
            } else if (union_location_id === 153) {
                this.assignment.rule_collection_id = this.unionJobRuleMx.report_rule_collection_id;
                this.assignment.guaranteed_hours = this.unionJobRuleMx.minimum_call_hours || this.assignment.guaranteed_hours;
                this.scaleType = 'studio';
            // Bus to
            } else if (union_location_id === 154) {
                this.assignment.rule_collection_id = this.unionJobRuleMx.bus_rule_collection_id;
                this.assignment.guaranteed_hours = this.unionJobRuleMx.minimum_call_hours || this.assignment.guaranteed_hours;
                this.scaleType = 'studio';
            // Distant Studio
            } else if (union_location_id === 155) {
                this.assignment.rule_collection_id = this.unionJobRuleMx.distant_studio_rule_collection_id;
                this.assignment.guaranteed_hours = this.unionJobRuleMx.distant_minimum_call_hours || this.assignment.guaranteed_hours;
                this.assignment.guaranteed_hours = this.unionJobRuleMx.minimum_call_hours || this.assignment.guaranteed_hours;
                this.scaleType = 'distant';
            } else {
                // old code
                // LA Studio Zone
                if (union_hired_from_id == 79 && union_jurisdiction_id == 1) {
                    this.assignment.rule_collection_id = this.unionJobRuleMx.studio_rule_collection_id;
                    this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.distant_minimum_call_hours;
                    this.scaleType = 'studio';
                    this.productionCity = true;
                    // console.log('Setting to LA Studio Zone.');

                // Still LA, Outside of Studio Zone.  Means bus/report/distant/distant studio
                } else if (union_hired_from_id == 79 || union_jurisdiction_id == 1) {
                    // Hotel and studio = distant studio
                    if (union_location_id == 155 || (this.mainLocation.transport_method_id == 78 && this.mainLocation.is_studio)) {
                        this.assignment.rule_collection_id = this.unionJobRuleMx.distant_studio_rule_collection_id;
                        this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.distant_minimum_call_hours;
                        this.scaleType = 'distant';
                        this.productionCity = true;
                        // console.log('Setting to LA Outside Zone.');

                    // Hotel = distant
                    } else if (union_location_id == 152 || (this.mainLocation.transport_method_id == 78)) {
                        this.assignment.rule_collection_id = this.unionJobRuleMx.distant_rule_collection_id;
                        this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.distant_minimum_call_hours;
                        // console.log('Setting to LA Distant.');
                        this.scaleType = 'distant';
                        this.productionCity = true;

                    // Report To
                    } else if (union_location_id == 153 || (this.mainLocation.transport_method_id == 76)) {
                        this.assignment.rule_collection_id = this.unionJobRuleMx.report_rule_collection_id;
                        this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.minimum_call_hours;
                        // console.log('Setting to LA Report to.');
                        this.scaleType = 'studio';
                        this.productionCity = true;

                    // Bus to
                    } else if (union_location_id == 154 || (this.mainLocation.transport_method_id == 77)) {
                        this.assignment.rule_collection_id = this.unionJobRuleMx.bus_rule_collection_id;
                        this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.minimum_call_hours;
                        // console.log('Setting to LA Bus To.');
                        this.scaleType = 'studio';
                        this.productionCity = true;
                    } else {
                        this.assignment.rule_collection_id = this.unionJobRuleMx.studio_rule_collection_id;
                        this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.minimum_call_hours;
                        // console.log ('Default to LA Zone.');
                        this.scaleType = 'studio';
                        this.productionCity = true;
                    }

                // NYC
                } else if (union_hired_from_id != 79 && union_jurisdiction_id == 2) {
                    this.assignment.rule_collection_id = this.unionJobRuleMx.studio_rule_collection_id;
                    this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.minimum_call_hours;
                    // console.log('Setting to NYC Studio.');
                    this.scaleType = 'studio';
                    this.productionCity = true;

                // Production City
                } else if (union_hired_from_id == 81) {
                    this.assignment.rule_collection_id = this.unionJobRuleMx.studio_rule_collection_id;
                    this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.studio_minimum_call_hours;
                    // console.log('Setting to Production City.');
                    this.scaleType = 'productionCity';
                    this.productionCity = true;

                // Local hire Outside of LA/NYC
                } else if (union_hired_from_id == 80) {
                    this.assignment.rule_collection_id = this.unionJobRuleMx.studio_rule_collection_id;
                    this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.studio_minimum_call_hours;
                    // console.log('Setting to Local Hire not in LA.');
                    this.scaleType = 'studio';
                    this.productionCity = false;

                // Everyone else is distant?
                // } else if (union_hired_from_id == 80) {
                //     this.assignment.rule_collection_id = this.unionJobRuleMx.distant_rule_collection_id;
                //     this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.distant_minimum_call_hours;
                //     // console.log('Setting to Distant.');
                //     this.scaleType = 'studio';
                //     this.productionCity = false;
                } else {
                    this.assignment.rule_collection_id = this.unionJobRuleMx.studio_rule_collection_id;
                    this.assignment.guaranteed_hours = this.assignment.guaranteed_hours || this.unionJobRuleMx.studio_minimum_call_hours;
                    // console.log ('No rule collection set.  Defaulting to Studio');
                    this.scaleType = 'studio';
                    this.productionCity = false;
                }
            }

            if (union_jurisdiction_id <= 2) this.productionCity = true; 
            else this.productionCity = false; 
            // console.log('Rule collection: ' + this.assignment.rule_collection_id);

            this.assignment.union_rule_overrides = { studio: null, distant: null, busto: null, reportto: null, studiodistant: null};

            // Prevent a loop
            if (! this.assignment.rule_collection_id) {
                // console.log ('Failed to get Rule Collection');
                // console.log (this.assignment.agreement_id, this.assignment.union_local_id, this.assignment.job_title_id, this.assignment.union_schedule_id, this.assignment.union_on_prod_id);
                // console.log (this.mainLocation.union_jurisdiction_id, this.unionLocalsFiltered);

                return false;
            }
            this.validateAllowanceLocType();
            this.calcEffectiveHourlyRate();
            this.populateCustomForms();
            this.loadScaleOnly();

            return true;
        },

        // Find the best ruleset match and whittle down from most accruate to least accurate
        findBestUjmxRules(job_title_id = null, agreement_id = null, union_local_id = null, union_schedule_id = null, union_on_prod_id = null, union_jurisdiction_id = null) {
            if (!job_title_id || !agreement_id) return false;
            // console.log('findBestUjmxRules', job_title_id, agreement_id, union_local_id, union_schedule_id, union_on_prod_id, union_jurisdiction_id);
            if (!this.assignment.union_location_id) this.assignment.union_location_id = 151;

            // Most specific
            let unionJobRuleMx = (this.unionJobRules.filter( (ruleset) =>
                parseInt(job_title_id) === parseInt(ruleset.job_title_id) &&
                parseInt(agreement_id) === parseInt(ruleset.agreement_id) &&
                (union_local_id ? parseInt(union_local_id) === parseInt(ruleset.union_local_id) : true) &&
                (union_schedule_id ? parseInt(union_schedule_id) === parseInt(ruleset.schedule_id) : true) &&
                (union_on_prod_id ? parseInt(union_on_prod_id) === parseInt(ruleset.on_prod_id) : true) &&
                (union_jurisdiction_id ? parseInt(union_jurisdiction_id) === parseInt(ruleset.jurisdiction_id) : true)
            )) || false;

            // This time without jurisdiction
            if (!unionJobRuleMx || unionJobRuleMx.length === 0) {
                unionJobRuleMx = (this.unionJobRules.filter( (ruleset) =>
                    parseInt(job_title_id) === parseInt(ruleset.job_title_id) &&
                    parseInt(agreement_id) === parseInt(ruleset.agreement_id) &&
                    (union_local_id ? parseInt(union_local_id) === parseInt(ruleset.union_local_id) : true) &&
                    (union_schedule_id ? parseInt(union_schedule_id) === parseInt(ruleset.schedule_id) : true) &&
                    (union_on_prod_id ? parseInt(union_on_prod_id) === parseInt(ruleset.on_prod_id) : true)
                )) || false;
            }

            // This time without jurisdiction or on-prod status
            if (!unionJobRuleMx || unionJobRuleMx.length === 0) {
                unionJobRuleMx = (this.unionJobRules.filter( (ruleset) =>
                    parseInt(job_title_id) === parseInt(ruleset.job_title_id) &&
                    parseInt(agreement_id) === parseInt(ruleset.agreement_id) &&
                    (union_local_id ? parseInt(union_local_id) === parseInt(ruleset.union_local_id) : true) &&
                    (union_schedule_id ? parseInt(union_schedule_id) === parseInt(ruleset.schedule_id) : true)
                )) || false;
            }

            // This time without jurisdiction, on-prod status, or schedule
            if (!unionJobRuleMx || unionJobRuleMx.length === 0) {
                unionJobRuleMx = (this.unionJobRules.filter( (ruleset) =>
                    parseInt(job_title_id) === parseInt(ruleset.job_title_id) &&
                    parseInt(agreement_id) === parseInt(ruleset.agreement_id) &&
                    (union_local_id ? parseInt(union_local_id) === parseInt(ruleset.union_local_id) : true)
                )) || false;
            }

            return unionJobRuleMx;
        },

        // Autocomplete for Agreement
        // Deprecated?
        updateAgreement(agreement) {
            this.assignment.agreement = agreement.name;
            this.assignment.agreement_id = agreement.id;
        },

        // Autocomplete for State selection
        updateLocationState(value){
            this.newLocation.state = value.code;
            this.newLocation.state_id = value.id;
        },

        // Autocomplete for Jurisdiction selection
        updateJurisdiction(value){
            this.newLocation.union_jurisdiction = value.code;
            this.newLocation.union_jurisdiction_id = value.id;
        },

        // Check to see if a new location is being added else update location settings
        async locationCheck( {target} ) {
            if(target.value === 'addLocation') {
                this.locationModal = true;
                $("#addLocationForm input[name='name']").focus();
            } else {
                this.getFilteredUnionLocalsByLocation(target.value, this.assignment.union_hired_from_id, true);
                this.updateLocationSettings (this.projectLocations.find(function(ind) { return  ind.id == target.value }));
            }
        },

        // Add a new location to the current entity
        async addLocation( {target} ) {
            if (this.checkForm("#addLocationForm")) {
                if (addressValidationFlag === 'true' && await this.checkAddressForm() === false) {
                    return;
                }

                if (this.isNewLocationUpdated) {
                    this.createDialog({ "title": "Address Updated", "body": 'The original address has been updated. Please review.', "buttonYesLabel": "OK", "buttonNo": false });
                    return;
                }
                // console.log ('Adding location');
                this.oasisApi.post('/projectLocations', this.newLocation)
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            this.locationModal = false;
                            this.location = this.newLocation.name;
                            this.location_id = response.data.id;

                            let locationData = {
                                id: response.data.id,
                                city: this.newLocation.city,
                                state_id: this.newLocation.state_id,
                                country_id: this.newLocation.country_id,
                                union_jurisdiction_id: this.newLocation.union_jurisdiction_id,
                                is_studio: this.newLocation.is_studio,
                                transport_method_id: this.newLocation.transport_method_id,
                            }
                            this.updateLocationSettings (locationData);
                            this.isNewLocationAddressChanged = false;
                            this.isNewLocationOverride = false;

                            this.oasisApi.get('/projectlocations')
                                .then(response => {
                                    this.projectLocations = (response.data);
                                    this.updateLocationSettings (locationData);
                                    setTimeout(function() {
                                        $("select[name='location_id'] option[value=" + locationData.id + "]").prop("selected", true);
                                        $("input[name='start_date']").focus();
                                        this.startCalendar = true;
                                    }, 200); 
                                    this.getFilteredUnionLocalsByLocation(locationData.id, this.assignment.union_hired_from_id, true);
                                })
                                .catch(error => { console.log(error); });
                        } else if (response.status == 400) {
                            if (Array.isArray(response.data)) {
                                let message = '';
                                for (let i = 0; i < response.data.length; i++) {
                                    let json = JSON.parse(response.data[i]);
                                    $("#addLocationForm input[name='" + json.field + "']").addClass('form-error2');
                                    message += json.message + "\n";
                                }
                                this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                            } else {
                                this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                            }
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data , "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    })
                    .catch(error => {
                        console.log('error: '); console.log(error); 
                    });
            }
        },

        async departmentCheck( {target} ) {
            if(target.value === 'addDepartment' || target.value === 'editDefault') {
                this.rowData = [];
                this.gridChanged = false; // for grid changes
                this.deptChanged = false;
                this.changedRow.clear();
                this.retrieveDefaultApprover = this.allApproverByEntity.filter((data) => data.department_id == null || data.department_id == undefined || data.department_id == '').sort((a,b) => {
                    if(a.approver_group > b.approver_group) return 1;
                    else if (a.approver_group < b.approver_group) return -1;
                    else {
                        if (a.approver_type > b.approver_type) return 1;
                        if (a.approver_type < b.approver_type) return -1;
                        return 0;
                    }
                });
                this.rowData = JSON.parse(JSON.stringify(this.retrieveDefaultApprover));
                if (target.value === 'addDepartment') {
                    // reset all values.
                    this.newDepartment.name = '';
                    this.newDepartment.description = '';
                    this.newDepartment.entity_id = entityId;
                    this.newDepartment.status = 1;
                    this.isFirstEdit = true;
                    this.departmentModal = true;
                    $("#addDepartmentForm input[name='name']").focus();
                } else {
                    this.defaultDeptModal = true;
                }
            }
            this.changes.assignment.push('department_id');
        },
        // Add a new department to the current entity
        addDepartment() {
            if (!this.checkForm("#addDepartmentForm")) return false;
            if (this.deptChanged) {
                // console.log ('Adding department');
                let method = this.assignment.department_id == 'addDepartment' ? 'post' : 'patch';
                if (method == 'patch') this.newDepartment.id = this.assignment.department_id;

                return this.oasisApi[method]('/departments', this.newDepartment)
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            if (response.data.count === 1) {
                                return response.data.results;
                            }
                            else return false;
                        } else if (response.status == 400 || response.status == 422) {
                            if (Array.isArray(response.data.errorMessages)) {
                                const errorMessages = response.data.errorMessages;
                                let message = '';
                                for (const i in errorMessages) {
                                    if (typeof errorMessages[i].message !== 'string') continue;
                                    $("#addDepartmentForm input[name='" + errorMessages[i].field + "']").addClass('form-error2');
                                    message += (errorMessages[i].message + "\n") || '';
                                }
                                this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                            } else {
                                this.createDialog({ "title": "Error", "body": response.data.message || 'Error adding the field.', "buttonNo": false, "buttonYesLabel": "OK"  });
                            }
                            return false;
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data , "buttonNo": false, "buttonYesLabel": "OK" });
                            return false;
                        }
                    })
                    .then(result => {
                        if (!result) return false;
                        this.assignment.department = result[0].name;
                        this.assignment.department_id = result[0].id;
                        // Refresh
                        this.oasisApi.get('/departments')
                            .then(response => { if (response && response.data && response.data.results) this.departments = response.data.results; })
                            .catch(error => { console.log(error); });
                        this.deptChanged = false;
                        return true;
                    })
                    .catch(error => {
                        console.log('error: '); console.log(error); return false;
                    });
            } else {
                return true;
            }
        },

        closeLocationModal() {
            this.locationModal = false;
        },

        async closeDepartmentModal() {
            if (this.isWorkflowChanged) this.getRecentAllApprover();
            this.isFirstEdit = false;
            this.departmentModal = false;
        },

        // Function to set certain legal defaults based on exempt status
        async updateExemptStatus(startup) {
            // Don't need to select rule collections if this is a loaded start
            if (this.type === 'edit' && !this.modified && startup === true) return true;
            this.checkUnion();
            this.updateLocationSettings();
            if (this.assignment.flsa_type_id == 1) {
                // Non-exempt
                this.union = false;
                // if non-union, all allowance location types will be 'All"
                if (this.assignment.kr_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.kr_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.kr_loc_type = 0;
                }
                if (this.assignment.krtax_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.krtax_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.krtax_loc_type = 0;
                }
                if (this.assignment.phone_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.phone_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.phone_loc_type = 0;
                }
                if (this.assignment.pd_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.pd_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.pd_loc_type = 0;
                }
                if (this.assignment.pd_taxable_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.pd_taxable_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.pd_taxable_loc_type = 0;
                }
                if (this.assignment.lodging_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.lodging_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.lodging_loc_type = 0;
                }
                if (this.assignment.lodging_tax_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.lodging_tax_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.lodging_tax_loc_type = 0;
                }
                if (this.assignment.cr_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.cr_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.cr_loc_type = 0;
                }

                if (this.assignment.legislative_type_id == 3 || this.assignment.legislative_type_id == 4) {
                    // User selects if US or CA rules
                    this.assignment.legislative_type_id = '';
                    this.assignment.rule_collection_id = '';
                }
                if (this.allowanceMessage) this.allowanceMessage = false;
            } else if (this.assignment.flsa_type_id == 2) {
                // Exempt
                this.union = false;
                this.assignment.agreement_id = null;
                this.assignment.union_local_id = null;
                this.assignment.union_flsa_type_id = null;
                this.assignment.union_on_prod_id = null;
                this.assignment.union_ruleset_id = null;
                this.assignment.union_schedule_id = null;
                this.assignment.union_rule_overrides = { studio: null, distant: null, busto: null, reportto: null, studiodistant: null};
                this.assignment.scale_rate = null;
                this.assignment.scale_stn = null;
                this.scale = null;
                this.scaleType = '';
                this.assignment.legislative_type_id = 3;
                this.assignment.rule_collection_id = 3;
                if (this.allowanceMessage) this.allowanceMessage = false;

                // if non-union, all allowance location types will be 'All"
                if (this.assignment.kr_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.kr_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.kr_loc_type = 0;
                }
                if (this.assignment.krtax_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.krtax_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.krtax_loc_type = 0;
                }
                if (this.assignment.phone_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.phone_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.phone_loc_type = 0;
                }
                if (this.assignment.pd_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.pd_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.pd_loc_type = 0;
                }
                if (this.assignment.pd_taxable_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.pd_taxable_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.pd_taxable_loc_type = 0;
                }
                if (this.assignment.lodging_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.lodging_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.lodging_loc_type = 0;
                }
                if (this.assignment.lodging_tax_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.lodging_tax_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.lodging_tax_loc_type = 0;
                }
                if (this.assignment.cr_loc_type) {
                    if (this.type == 'edit') ((this.$refs['assignment.cr_loc_type'] || {}).classList || {}).add('form-change');
                    this.assignment.cr_loc_type = 0;
                }

            } else if (this.assignment.flsa_type_id == 3) {
                // Union
                this.union = true;
                this.assignment.work_day = 0; // reset when user change to union.
                this.assignment.legislative_type_id = 4;
                this.assignment.rule_collection_id = ''; // User selects custom rules
                this.getFilteredUnionLocalsByLocation(this.assignment.location_id, this.assignment.union_hired_from_id, true);
            } else if (this.assignment.flsa_type_id == 4) {
                // Custom Non-Union
                this.union = true;
                this.assignment.legislative_type_id = 4;
                this.assignment.rule_collection_id = ''; // User selects custom rules
            }

            // Force legislative type to change to force save
            if (this.existingStart === true && startup !== true) $("select[name='legislative_type_id']").addClass('form-change')
            
            if (this.isCanada && parseInt(this.assignment.flsa_type_id) === 3) {
                this.assignment.metadata.includeVacation = false;
                this.lockedInclVac = true;
            } else if(this.lockedInclVac) {
                this.lockedInclVac = false;
            }

            this.calcEffectiveHourlyRate();
            // non-union and exempt
            if (this.assignment.flsa_type_id == 2 && !this.disabledRateUnits.includes("1")) {
                this.addDisabledRateUnits("1");
                if (this.assignment.rate_unit_id == 1 ) {
                    this.assignment.rate_unit_id = '';
                    if (this.type === 'edit') ((this.$refs['assignment.rate_unit_id'] || {}).classList || {}).add('form-change');
                }
            } else if (this.disabledRateUnits.includes("1")) {
                this.removeDisabledRateUnits("1");
            }
        },

        // Function to set certain legal defaults based on the default location of the employee
        async updateLocationSettings (data) {
            if (data && data.state_id) this.assignment.location_id = data.id;
            let california = false;

            // Resident State stuff, i.e. don't allow US Hourly rules if the employee/job is in California
            // California has the highest restrictions for non-foreign interests
            if (
                this.assignment.resident_state_id == 5 || 
                this.mainLocationState === 'CA' || 
                // parseInt(this.assignment.legislative_type_id) === 2 || 
                (this.employee || {}).main_state_id == 5 || 
                this.hiredFromCalifornia() || 
                (data && data.state_id == 5)
            ) {
                california = true;
            }

            // Exempt
            if (parseInt(this.assignment.flsa_type_id) === 2) {
                if (parseInt(this.assignment.flsa_type_id) === 1 && parseInt(this.assignment.legislative_type_id) !== 3) this.assignment.legislative_type_id = 3;
                this.removeDisabledLegislativeType("3");
                this.addDisabledLegislativeType("1");
                this.addDisabledLegislativeType("2");
                this.addDisabledLegislativeType("4");
                this.addDisabledLegislativeType("5");
            // Check for foreign pay next.
            } else if (this.isCanadianCurrency) {
                if (this.assignment.flsa_type_id == 1) this.assignment.legislative_type_id = 5;
                this.removeDisabledLegislativeType("5");
                this.addDisabledLegislativeType("1");
                this.addDisabledLegislativeType("2");
                this.addDisabledLegislativeType("3");
            } else if (this.isForeign) {
                if (this.assignment.flsa_type_id == 1) this.assignment.legislative_type_id = 1;
                this.removeDisabledLegislativeType("1");
                this.removeDisabledLegislativeType("2");
                this.addDisabledLegislativeType("3");
                this.addDisabledLegislativeType("5");
            } else if (california) {
                this.assignment.currency_id = 1; // Can only pay USD or CAD
                if (!this.assignment.flsa_type_id) this.assignment.flsa_type_id = 1;
                if (parseInt(this.assignment.flsa_type_id) === 1 && parseInt(this.assignment.legislative_type_id) !== 2) this.assignment.legislative_type_id = 2;
                if (parseInt(this.assignment.flsa_type_id) === 1 && !this.assignment.rule_collection_id) this.assignment.rule_collection_id = 2;
                if (this.assignment.flsa_type_id == 1 || this.assignment.legislative_type_id == 1) this.assignment.legislative_type_id = 2;
                if ((this.employee || {}).main_state_id == 5) this.assignment.resident_state_id = 5;
                this.removeDisabledLegislativeType("2");
                this.addDisabledLegislativeType("1");
                this.addDisabledLegislativeType("3");
                this.addDisabledLegislativeType("5");
            } else {
                this.assignment.currency_id = 1; // Can only pay USD or CAD
                if (!this.assignment.flsa_type_id) this.assignment.flsa_type_id = 1;
                if (parseInt(this.assignment.flsa_type_id) === 1 && parseInt(this.assignment.legislative_type_id) !== 1) this.assignment.legislative_type_id = 1;
                this.removeDisabledLegislativeType("1");
                this.addDisabledLegislativeType("2"); // Disable California otherwise (PRO-2001)
                this.addDisabledLegislativeType("3");
                this.addDisabledLegislativeType("5");
            }

            // Unselect forms that are not necessary
            this.populateCustomForms();

            // Only run if location data changed
            if (typeof data === 'undefined' || ! data.hasOwnProperty('state_id')) return;
            this.assignment.country_id = data.country_id;
            this.defaultCity = data.city;
            this.defaultState = data.state_id;

            // Don't need to select rule collections if this is a loaded start
            if (this.type === 'edit' && !this.modified) return true;

            this.calcEffectiveHourlyRate();
        },

        addDisabledLegislativeType(id) {
            if (! this.disabledLegislativeTypes.includes(id)) this.disabledLegislativeTypes.push(id);
        },

        removeDisabledLegislativeType(id) {
            if (this.disabledLegislativeTypes.includes(id)) this.disabledLegislativeTypes.splice(this.disabledLegislativeTypes.indexOf(id),1);
        },

        hiredFromCalifornia() {
            return this.assignment.union_hired_from_id == 79 || this.assignment.union_hired_from_id == 164
        },

        changedUnionLocal(event) {
            if (this.multiSelectMissing) this.multiSelectMissing = false;
            this.multiSelectChanged = true;
            this.updateLocals(event);
        },

        // Select the correct union Local.  Assuming that our locals are coming from a list picked of unionLocalsFiltered
        async updateLocals(event) {
            let agreementLocalId;
            let agreementId;
            let unionLocalId;

            // Use event info first to figure out the agreementLocal
            if (event !== undefined) agreementLocalId = event.id;

            /* need to set empty after select another union local. there are 3 cases
            1. change union local directly through button
            2. no union local, seach Job title first - with matching (only one result)
            3. no union local, search Job title first - no matching (show all union that related to selected Job title)
            we support current way (case 2, 3)
            resetJobInfoToggle is to distingish that is trigered by case 1 or case 3 so 
            If case 1, need to reset Job field. 
            If case 3, don't need to reset Job field (already filtered and user will pick) */
            if (event && this.resetJobInfoToggle) {
                this.assignment.job_title = '';
                this.assignment.job_title_id = '';
                this.assignment.job_title_override = '';
                this.assignment.occ_code = '';
                this.selectedJobTitle = '';
            }

            if (!this.resetJobInfoToggle) this.resetJobInfoToggle = true;

            // No selection event (likely loading an existing start)
            if (!agreementLocalId) {
                agreementId = this.assignment.agreement_id;
                unionLocalId = this.assignment.union_local_id;
            }
            let agreementLocal = this.agreementLocals.find((aLocal) => agreementLocalId ? aLocal.id == agreementLocalId : (aLocal.agreement_id == agreementId && aLocal.union_local_id == unionLocalId));
            if (agreementLocal) {
                this.assignment.agreement_id = agreementLocal.agreement_id;
                this.assignment.union_local_id = agreementLocal.union_local_id;
                this.selectedAgreementLocal = agreementLocal;

                this.unionLocalJobFilter = this.assignment.union_local_id;
                this.agreementJobFilter = this.assignment.agreement_id;
           
                this.updateUnionSchedule();
                this.calcEffectiveHourlyRate();

                // Set Occ code
                await this.getUnionOccCode(this.assignment);
                return true;
            } else {
                this.unionLocalJobFilter = null;
                this.agreementJobFilter = null;
                return false;
            }
        },

        deSelectUnionLocals() {
            if (this.multiSelectMissing) this.multiSelectMissing = false;
            this.multiSelectChanged = true;
            this.assignment.agreement_id = '';
            this.assignment.union_local_id = '';
            return false;
        },

        // Easy validation, e.g. if fields are required
        checkForm(form) {
            let isMissing = false;
            let isError = false;
            if (this.union) {
                // this way is for multiselect
                if (!this.assignment.union_local_id) {
                    this.multiSelectMissing = true;
                    isMissing = true;
                }
            }
            if (form) {
                var scope = [ form + " input", form + " select" ];
            } else {
                var scope = [ "input", "select" ];
            }

            $.each(scope, function (index, value) {
                $(value).filter(".form-error2").each(function(ind, field){
                    $(field).removeClass("form-error2");
                });

                $(value).filter(".form-error").each(function(ind, field){
                    if (!isError) isError = true;
                });

                $(value).filter("[required]:visible").each(function(ind, field){
                    $(field).removeClass("form-missing");

                    if ($(field).val() == "") {
                        $(field).addClass("form-missing");
                        if (!isMissing) isMissing = true;
                    } else {
                        $(field).removeClass("form-missing");
                    }
                });
            });

            if (isMissing) {
                this.createDialog({ "title": "Warning", "body": 'Please add missing data before submitting.', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            } else if (isError) {
                this.createDialog({ "title": "Warning", "body": 'Please fix errors before submitting.', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            } else {
                return true;
            }
        },

        // used to set timecard header after loading employee
        updateAssignment(assignment) {
            let keys = Object.keys(assignment);
            for (let i = 0; i < keys.length; i++) {
                let currKey = keys[i];
                if (assignment[currKey]) {
                    // For autocomplete, need special ways to assign values
                    if (currKey === 'employee') {
                        this.assignment.employee = assignment.employee;
                    } else if (currKey === 'job_title_id') {
                        const job = (assignment.union_local_id ? this.unionJobs : this.allJobs).find(job => parseInt(job.id) === parseInt(assignment[currKey])) || {};
                        this.assignment.job_title_id = assignment[currKey];
                        this.assignment.job_title = job.name || assignment.job_title_override;
                        this.selectedJobTitle = job.name || assignment.job_title_override;
                        this.selectedUnionJobTitle = job.name || assignment.job_title_override;
                    } else if (currKey === 'location') {
                        // this.assignment.location = { "name": assignment.location, "id": assignment.location_id };
                        this.assignment.location = assignment.location;
                    } else if (currKey === 'custom_forms') {
                        if (typeof assignment.custom_forms === 'string' && this.isJson(assignment.custom_forms)) {
                            this.assignment.custom_forms = this.selectedCustomForms = JSON.parse (assignment.custom_forms);
                        } else if (typeof assignment.custom_forms === 'object') {
                            this.assignment.custom_forms = this.selectedCustomForms = assignment.custom_forms;
                        } else {
                            // Un]known Custom Form
                            // console.log(assignment.custom_forms);
                        }
                    } else if (currKey === 'custom_form_fields' && typeof assignment.custom_form_fields === 'string' && this.isJson(assignment.custom_form_fields)) {
                        this.assignment.custom_form_fields = JSON.parse (assignment.custom_form_fields);
                    } else if (currKey === 'custom_form_employer_fields' && typeof assignment.custom_form_employer_fields === 'string' && this.isJson(assignment.custom_form_employer_fields)) {
                        this.assignment.custom_form_employer_fields = JSON.parse (assignment.custom_form_employer_fields);
                    } else if (currKey === 'union_rule_overrides' && typeof assignment.union_rule_overrides === 'string' && this.isJson(assignment.union_rule_overrides)) {
                        this.assignment.union_rule_overrides = JSON.parse(assignment.union_rule_overrides);
                    } else if (currKey === 'metadata') {
                        if (typeof assignment.metadata === 'string' && this.isJson(assignment.metadata)) {
                            this.assignment.metadata = JSON.parse(assignment.metadata);
                        } else {
                            this.assignment.metadata = assignment.metadata ? Object.assign({}, assignment.metadata) : {};
                        }
                        // Temp code to catchup on existing Canadian assignments
                        if (this.assignment.metadata && !this.assignment.metadata.hasOwnProperty('includeVacation')) {
                            this.assignment.metadata.includeVacation = true;
                        }
                    } else {
                        this.assignment[keys[i]] = assignment[keys[i]];
                    }
                }
            }

            // Create a shallow copy for change tracking
            this.assignmentOriginal = Object.assign({}, this.assignment);

            // autocomplete set up for preselect
            this.selected_budget_code = assignment.budget_code || '';
            this.selected_fringe_code = assignment.fringe_code || '';
            this.selected_free_field = assignment.free_field || '';
            this.selected_free_field2 = assignment.free_field2 || '';
            this.selected_series_code = assignment.series_code || '';
            this.selected_location_code = assignment.location_code || '';
            this.selected_set_code = assignment.set_code || '';
            this.selected_pw_budget_code = assignment.pw_budget_code || '';
            this.selected_pw_fringe_code = assignment.pw_fringe_code || '';
            this.selected_pw_free_field = assignment.pw_free_field || '';
            this.selected_pw_free_field2 = assignment.pw_free_field2 || '';
            this.selected_pw_series_code = assignment.pw_series_code || '';
            this.selected_pw_location_code = assignment.pw_location_code || '';
            this.selected_pw_set_code = assignment.pw_set_code || '';
            this.selected_kr_code = assignment.kr_code || '';
            this.selected_kr_free_field = assignment.kr_free_field || '';
            this.selected_kr_free_field2 = assignment.kr_free_field2 || '';
            this.selected_krtax_code = assignment.krtax_code || '';
            this.selected_krtax_free_field = assignment.krtax_free_field || '';
            this.selected_krtax_free_field2 = assignment.krtax_free_field2 || '';
            this.selected_pd_code = assignment.pd_code || '';
            this.selected_pd_free_field = assignment.pd_free_field || '';
            this.selected_pd_free_field2 = assignment.pd_free_field2 || '';
            this.selected_pd_taxable_code = assignment.pd_taxable_code || '';
            this.selected_pdtax_free_field = assignment.pdtax_free_field || '';
            this.selected_pdtax_free_field2 = assignment.pdtax_free_field2 || '';
            this.selected_lodging_code = assignment.lodging_code || '';
            this.selected_lodging_free_field = assignment.lodging_free_field || '';
            this.selected_lodging_free_field2 = assignment.lodging_free_field2 || '';
            this.selected_lodging_tax_code = assignment.lodging_tax_code || '';
            this.selected_lodging_tax_free_field = assignment.lodging_tax_free_field || '';
            this.selected_lodging_tax_free_field2 = assignment.lodging_tax_free_field2 || '';
            this.selected_phone_allow_code = assignment.phone_allow_code || '';
            this.selected_phone_allow_free_field = assignment.phone_allow_free_field || '';
            this.selected_phone_allow_free_field2 = assignment.phone_allow_free_field2 || '';
            this.selected_cr_code = assignment.cr_code || '';
            this.selected_cr_free_field = assignment.cr_free_field || '';
            this.selected_cr_free_field2 = assignment.cr_free_field2 || '';
            this.selected_agent_code = assignment.agent_code || '';
            this.selected_agent_free_field = assignment.agent_free_field || '';
            this.selected_agent_free_field2 = assignment.agent_free_field2 || '';

            // Make sure to enable the legislative type
            if (this.disabledLegislativeTypes.includes(String(assignment.legislative_type_id))) this.removeDisabledLegislativeType(String(assignment.legislative_type_id));

            this.checkUnion();
            if (this.assignment.union_local_id) {
                this.validateAllowanceLocType();
                setTimeout(() => { this.updateLocals() }, 200);
            } else {
                this.updateExemptStatus(true);
            }
        },

        // used to clone a start to a new employee
        copyAssignment(assignment) {
            let assignmentToCopy;
            if (assignment && assignment.hash) {
                // console.log('using supplied assignment', assignment, assignment.hash);
                assignmentToCopy = Object.assign({}, assignment);
            } else if (this.assignment.hash) {
                // console.log('using current assignment', this.assignment, this.assignment.hash);
                assignmentToCopy = Object.assign({}, this.assignment);
            }
            
            if (!assignmentToCopy) {
                // console.log(assignment, this.assignment.hash);
                alert('No assignment found to copy.');
                return false;
            }

            // Reset the assignment and employee objects
            this.assignment = {};
            this.employee = {};
            this.empSet = false;
            this.resetStart()

            // Update URL so users are not confused by the previous assignment hash
            const url = new URL(window.location.href);
            url.pathname = url.pathname.replace(/New.*/, '').replace(/edit.*/, 'create')
            window.history.replaceState(null, '', url.toString());

            const assignmentPropsToSkip = [
                'id', 'hash', 'status', 'employee_id', 'employee', 'time_added', 'time_updated', 'last_name', 'first_name',
                'propay_id', 'use_loanout', 'loanout_status', 'aca_status_id', 'exemptions', 'exemptions_state',
                'list_a_type_id', 'list_a_auth', 'list_a_number', 'list_a_exp', 'list_b_type_id', 'list_b_auth', 'list_b_number', 'list_b_exp', 'list_c_type_id', 'list_c_auth', 'list_c_number', 'list_c_exp',
                'ee_list_a_type_id', 'ee_list_a_auth', 'ee_list_a_number', 'ee_list_a_exp', 'ee_list_b_type_id', 'ee_list_b_auth', 'ee_list_b_number', 'ee_list_b_exp', 'ee_list_c_type_id', 'ee_list_c_auth', 'ee_list_c_number', 'ee_list_c_exp',
                'dd_status', 'dd_bank_type_1', 'dd_bank_name_1', 'dd_bank_city_state_1', 'dd_bank_account_name_1', 'dd_bank_account_1', 'dd_bank_routing_1', 'dd_bank_branch_1', 'dd_bank_amount_1', 'dd_bank_percent_1', 'dd_bank_type_2', 'dd_bank_name_2', 'dd_bank_city_state_2', 'dd_bank_account_name_2', 'dd_bank_account_2', 'dd_bank_routing_2', 'dd_bank_branch_2', 'dd_bank_amount_2', 'dd_bank_percent_2',
                'employee_comments',
                'employee_status', 'employer_status', 'paper_form',
                'custom_forms', 'custom_form_fields',
                'termination_forms', 'termination_form_fields',
                'canada_form_fields',
                'certification_type_id',
                'modified', 'metadata',
            ];
 
            let keys = Object.keys(assignmentToCopy);
            for (let i = 0; i < keys.length; i++) {
                let currKey = keys[i];
                if (assignmentPropsToSkip.includes(currKey)) {
                    // console.log('Skipping assignment property: ' + currKey);
                    continue;
                }
                if (assignmentToCopy[currKey]) {
                    // For autocomplete, need special ways to assign values
                    if (currKey === 'job_title_id') {
                        const job = (assignmentToCopy.union_local_id ? this.unionJobs : this.allJobs).find(job => parseInt(job.id) === parseInt(assignmentToCopy[currKey])) || {};
                        this.assignment.job_title_id = assignmentToCopy[currKey];
                        this.assignment.job_title = job.name || assignmentToCopy.job_title_override;
                        this.selectedJobTitle = job.name || assignmentToCopy.job_title_override;
                        this.selectedUnionJobTitle = job.name || assignmentToCopy.job_title_override;
                    // } else if (currKey === 'location') {
                        // this.assignment.location = assignmentToCopy.location;
                    } else if (currKey === 'custom_forms') {
                        if (typeof assignmentToCopy.custom_forms === 'string' && this.isJson(assignmentToCopy.custom_forms)) {
                            this.assignment.custom_forms = this.selectedCustomForms = JSON.parse (assignmentToCopy.custom_forms);
                        } else if (typeof assignmentToCopy.custom_forms === 'object') {
                            this.assignment.custom_forms = this.selectedCustomForms = assignmentToCopy.custom_forms;
                        } else {
                            // Un]known Custom Form
                            // console.log(assignment.custom_forms);
                        }
                        this.assignment.custom_form_employer_fields = JSON.parse (assignmentToCopy.custom_form_employer_fields);
                    } else if (currKey === 'union_rule_overrides' && typeof assignmentToCopy.union_rule_overrides === 'string' && this.isJson(assignmentToCopy.union_rule_overrides)) {
                        this.assignment.union_rule_overrides = JSON.parse(assignmentToCopy.union_rule_overrides);
                    } else {
                        this.assignment[keys[i]] = assignmentToCopy[keys[i]];
                    }
                }
            }

            // autocomplete set up for preselect
            this.selected_budget_code = assignmentToCopy.budget_code || '';
            this.selected_fringe_code = assignmentToCopy.fringe_code || '';
            this.selected_free_field = assignmentToCopy.free_field || '';
            this.selected_free_field2 = assignmentToCopy.free_field2 || '';
            this.selected_series_code = assignmentToCopy.series_code || '';
            this.selected_location_code = assignmentToCopy.location_code || '';
            this.selected_set_code = assignmentToCopy.set_code || '';
            this.selected_pw_budget_code = assignmentToCopy.pw_budget_code || '';
            this.selected_pw_fringe_code = assignmentToCopy.pw_fringe_code || '';
            this.selected_pw_free_field = assignmentToCopy.pw_free_field || '';
            this.selected_pw_free_field2 = assignmentToCopy.pw_free_field2 || '';
            this.selected_pw_series_code = assignmentToCopy.pw_series_code || '';
            this.selected_pw_location_code = assignmentToCopy.pw_location_code || '';
            this.selected_pw_set_code = assignmentToCopy.pw_set_code || '';
            this.selected_kr_code = assignmentToCopy.kr_code || '';
            this.selected_kr_free_field = assignmentToCopy.kr_free_field || '';
            this.selected_kr_free_field2 = assignmentToCopy.kr_free_field2 || '';
            this.selected_krtax_code = assignmentToCopy.krtax_code || '';
            this.selected_krtax_free_field = assignmentToCopy.krtax_free_field || '';
            this.selected_krtax_free_field2 = assignmentToCopy.krtax_free_field2 || '';
            this.selected_pd_code = assignmentToCopy.pd_code || '';
            this.selected_pd_free_field = assignmentToCopy.pd_free_field || '';
            this.selected_pd_free_field2 = assignmentToCopy.pd_free_field2 || '';
            this.selected_pd_taxable_code = assignmentToCopy.pd_taxable_code || '';
            this.selected_pdtax_free_field = assignmentToCopy.pdtax_free_field || '';
            this.selected_pdtax_free_field2 = assignmentToCopy.pdtax_free_field2 || '';
            this.selected_lodging_code = assignmentToCopy.lodging_code || '';
            this.selected_lodging_free_field = assignmentToCopy.lodging_free_field || '';
            this.selected_lodging_free_field2 = assignmentToCopy.lodging_free_field2 || '';
            this.selected_lodging_tax_code = assignmentToCopy.lodging_tax_code || '';
            this.selected_lodging_tax_free_field = assignmentToCopy.lodging_tax_free_field || '';
            this.selected_lodging_tax_free_field2 = assignmentToCopy.lodging_tax_free_field2 || '';
            this.selected_phone_allow_code = assignmentToCopy.phone_allow_code || '';
            this.selected_phone_allow_free_field = assignmentToCopy.phone_allow_free_field || '';
            this.selected_phone_allow_free_field2 = assignmentToCopy.phone_allow_free_field2 || '';
            this.selected_cr_code = assignmentToCopy.cr_code || '';
            this.selected_cr_free_field = assignmentToCopy.cr_free_field || '';
            this.selected_cr_free_field2 = assignmentToCopy.cr_free_field2 || '';
            this.selected_agent_code = assignmentToCopy.agent_code || '';
            this.selected_agent_free_field = assignmentToCopy.agent_free_field || '';
            this.selected_agent_free_field2 = assignmentToCopy.agent_free_field2 || '';

            // Make sure to enable the legislative type
            if (this.disabledLegislativeTypes.includes(String(assignmentToCopy.legislative_type_id))) this.removeDisabledLegislativeType(String(assignmentToCopy.legislative_type_id));

            this.checkUnion();
            if (this.assignment.union_local_id) {
                this.validateAllowanceLocType();
                setTimeout(() => { this.updateLocals() }, 200);
            } else {
                this.updateExemptStatus(true);
            }
        },

        checkCertificationsRequired() {
            if (typeof this.harassmentCertification === 'undefined' || ! this.harassmentCertification) {
                return;
            }
            // For sexual harassment training, New York and California workers need to be certified.  California will also need employees to be identitied as regular employees or supervisors
            if (this.mainLocationState === 'CA' && this.is_supervisor === true) {
                this.assignment.certification_type_id = 2;
            } else if (this.mainLocationState === 'CA') {
                this.assignment.certification_type_id = 1;
            } else if (this.mainLocationState === 'NY') {
                this.assignment.certification_type_id = 3;
            } else if (this.mainLocationState === 'ON') {
                this.assignment.certification_type_id = 4;

            // Allow non-CA and NY workers to use the certification
            } else if (this.companyHarassmentSupCertificateId && this.is_supervisor === true) {
                this.assignment.certification_type_id = this.companyHarassmentSupCertificateId;
            } else if (this.companyHarassmentCertificateId) {
                this.assignment.certification_type_id = this.companyHarassmentCertificateId;
            } else {
                this.assignment.certification_type_id = null;
            }
        },

        // Get Relevant OT Rules from Rule Collection
        async getOtRules() {
            let ot = await this.oasisApi.get('/calcHourlyRate/' + this.assignment.rule_collection_id);
            let otRules = (ot.data || {}).results;
            if (!otRules) {
                this.currentOtRules = undefined;
                console.log ('Error. No OT rules');
            } else {
                this.currentOtRules = otRules;
            }
            // console.log('otRules');
            // console.log(otRules);
        },

        // Calc the effective rate for hourly employees
        // Weekly = hourly ?
        // Assume 8 hour days if no guarantee?
        // TODO use the rules to calc
        async calcEffectiveHourlyRate(unsetIsPaidScale=false) {
            this.rateFieldDisabled = true;
            if (unsetIsPaidScale === true) {
                this.assignment.is_paid_scale = false;
            }
            this.checkCertificationsRequired();
            this.checkUnion();
            this.checkRuleCollections();

            // Is there enough data?
            if (! this.assignment.legislative_type_id || ! this.assignment.rate || ! this.assignment.rate_unit_id) {
                this.assignment.hourly_rate = '';
                this.rateFieldDisabled = false;
                return false; 
            // Do not show an hourly rate if exempt
            } else if (parseInt (this.assignment.legislative_type_id) === 3) {
                this.assignment.hourly_rate = '';
                await this.checkMinWage();
                this.rateFieldDisabled = false;
                return true;
            }

            let rate_unit_id = parseInt (this.assignment.rate_unit_id);
            if (isNaN(rate_unit_id)) {
                this.assignment.hourly_rate = '';
                await this.checkMinWage();
                this.rateFieldDisabled = false;
                return false; 
            }

            if (parseInt (this.assignment.rate_unit_id) !== 10) {
                this.assignment.rate_comment = '';
            }

            // Set defaults
            let hours_per_day = (this.assignment.rate_unit_id == 2 && parseInt(this.assignment.guaranteed_hours)) || 8;
            let hours_6th_day = (parseFloat(this.assignment.guaranteed_hours_6th)) || 0;
            let hours_7th_day = (parseFloat(this.assignment.guaranteed_hours_7th)) || 0;
            let hours_per_week = (this.assignment.rate_unit_id == 3 && parseInt(this.assignment.guaranteed_hours)) || hours_per_day * 5 || 40;
            let hourly_rate = undefined;
            if (hours_per_week > 40) {
                hours_per_day = hours_per_week / 5;
            }

            // console.log('Hours per day: ' + hours_per_day);
            // console.log('Hours per week: ' + hours_per_week);
            // Guaranteed hours?
            let guaranteed_unit_id = parseInt (this.assignment.guaranteed_hours_unit_id);
            if (isNaN(guaranteed_unit_id)) { guaranteed_unit_id = undefined; }

            if (! isNaN(this.assignment.guaranteed_hours) && (this.assignment.guaranteed_hours*1 > 0)) {
                let guaranteed_hours_per_day = undefined;
                if (guaranteed_unit_id && guaranteed_unit_id === 8) {
                    guaranteed_hours_per_day = this.assignment.guaranteed_hours*1;
                } else if (guaranteed_unit_id && guaranteed_unit_id === 9) {
                    guaranteed_hours_per_day = this.assignment.guaranteed_hours*1 / 5;
                } else {
                    guaranteed_hours_per_day = undefined;
                }

                if (guaranteed_hours_per_day > 8) {
                    hours_per_day = guaranteed_hours_per_day;
                    hours_per_week = guaranteed_hours_per_day * 5;
                }
            }

            // Do we know ot rules?
            if (!this.assignment.rule_collection_id && this.union) {
                this.updateUnionSchedule();
            } else if (!this.assignment.rule_collection_id && ! this.union) {
                this.updateLocationSettings();
            }

            await this.getOtRules();
            const otRules = this.currentOtRules;

            let st, ot1, ot2, ot3, ot1_rate, ot2_rate, ot3_rate;
            // Temp for 6th day and 7th day calcs
            let st_6_rate = 1.5;
            let ot1_6_rate = 2;
            let ot2_6_rate = 0;
            let st1_7_rate = 2;
            let ot1_7_rate = 0;
            let ot2_7_rate = 0;
            let st_6 = 8;
            let st_7 = 20;

            if (otRules && Array.isArray(otRules) && otRules[0]) {
                let straight  = (otRules[0]) ? otRules[0] : {"multiplier":1,"hourStart":0,"hourEnd":8}; 
                let overtime1 = (otRules[1]) ? otRules[1] : {"multiplier":0,"hourStart":0,"hourEnd":0}; 
                let overtime2 = (otRules[2]) ? otRules[2] : {"multiplier":0,"hourStart":0,"hourEnd":0}; 
                let overtime3 = (otRules[3]) ? otRules[3] : {"multiplier":0,"hourStart":0,"hourEnd":0}; 

                ot1_rate = overtime1.multiplier;
                ot2_rate = overtime2.multiplier;
                ot3_rate = overtime3.multiplier;

                if (overtime3.hourStart && hours_per_day > overtime3.hourStart) {
                    // console.log ('Greater than ot3 threshold');
                    ot3 = hours_per_day - overtime3.hourStart;
                    ot2 = overtime2.hourEnd - overtime2.hourStart;
                    ot1 = overtime1.hourEnd - overtime1.hourStart;
                    st = straight.hourEnd;
                } else if (overtime2.hourStart && hours_per_day > overtime2.hourStart) {
                    // console.log ('Greater than ot2 threshold');
                    ot3 = 0;
                    ot2 = hours_per_day - overtime2.hourStart;
                    ot1 = overtime1.hourEnd - overtime1.hourStart;
                    st = straight.hourEnd;
                } else if (overtime1.hourStart && hours_per_day > overtime1.hourStart) {
                    // console.log ('Greater than ot1 threshold');
                    ot3 = 0;
                    ot2 = 0;
                    ot1 = hours_per_day - overtime1.hourStart;
                    st = straight.hourEnd;
                } else {
                    // console.log ('Straight Time Only');
                    ot3 = 0;
                    ot2 = 0;
                    ot1 = 0;
                    // Allow min calls/guarantees of less than 8 hours only for union
                    st = (!this.union && hours_per_day < 8) ? 8 : (hours_per_day || 8);
                }
            } else {
                // Don't have rule breakdown so
                // For now, only allow for US and Cali OT rates
                ot1_rate = 1.5;
                ot2_rate = 2;
                if (parseInt (this.assignment.legislative_type_id) === 3) {
                    ot2 = 0;
                    ot1 = 0;
                    st = 8;
                    hours_per_day = 8;
                    hours_per_week = 40;
                } else if (
                    parseInt (this.assignment.legislative_type_id) === 2
                    || 
                    parseInt (this.assignment.rule_collection_id) === 2
                    || 
                    parseInt (this.assignment.rule_collection_id) === 6
                    || 
                    parseInt (this.assignment.rule_collection_id) === 8
                    || 
                    parseInt (this.assignment.rule_collection_id) === 9
                ) {
                    if (hours_per_day > 12) {
                        ot2 = hours_per_day - 12;
                        ot1 = 4
                        st = 8;
                    } else if (hours_per_day > 8) {
                        ot2 = 0;
                        ot1 = hours_per_day - 8
                        st = 8;
                    } else {
                        ot2 = 0;
                        ot1 = 0;
                        st = hours_per_day;
                    }
                } else if (
                    parseInt (this.assignment.rule_collection_id) === 5
                    || 
                    parseInt (this.assignment.rule_collection_id) === 7
                ) {
                    if (hours_per_day > 8) {
                        ot2 = 0;
                        ot1 = hours_per_day - 8
                        st = 8;
                    } else {
                        ot2 = 0;
                        ot1 = 0;
                        st = hours_per_day;
                    }
                } else if (parseInt (this.assignment.legislative_type_id) === 1) {
                    ot2_rate = 1.5;
                    if (hours_per_week > 40) {
                        ot2 = 0;
                        if (rate_unit_id === 2) {
                            ot1_rate = 1;
                        } 
                        ot1 = (hours_per_week - 40) / 5;
                        st = 8;
                    } else {
                        ot2 = 0;
                        ot1 = 0;
                        st = hours_per_week / 5;
                    }
                }
            }

            // console.log(this.assignment.rate);
            // console.log(st, ot1_rate, ot1, ot2_rate, ot2, ot3_rate, ot3);
            // console.log(st + ot1_rate*ot1 + ot2_rate*ot2 + ot3_rate*ot3);
            // console.log(st + ot1_rate*ot1 + ot2_rate*ot2 + ot3_rate*ot3 + st_6_rate*(hours_6th_day && hours_6th_day > st_6 ? st_6 : hours_6th_day) + ot1_6_rate*(hours_6th_day && hours_6th_day > st_6 ? hours_6th_day - st_6 : 0));
            // console.log(st_6_rate*(hours_6th_day && hours_6th_day > st_6 ? st_6 : hours_6th_day));
            // console.log(ot1_6_rate*(hours_6th_day && hours_6th_day > st_6 ? hours_6th_day - st_6 : 0));
            // console.log((this.assignment.rate*1) / (5 * (st + ot1_rate*ot1 + ot2_rate*ot2 + ot3_rate*ot3) + st_6_rate*hours_6th_day));
            // Rate = Total / (8 + 1.5h + 2i)
            // Hourly
            if (rate_unit_id === 1) {
                hourly_rate = this.assignment.rate;

            // Day Rate
            } else if (rate_unit_id === 2) {
                hourly_rate = this.assignment.rate*1 / (st + ot1_rate*ot1 + ot2_rate*ot2 + ot3_rate*ot3);

            // Weekly Rate
            } else if (rate_unit_id === 3) {
                hourly_rate = (this.assignment.rate*1) / (5 * (st + ot1_rate*ot1 + ot2_rate*ot2 + ot3_rate*ot3) + st_6_rate*hours_6th_day);

            // Monthly Rate
            } else if (rate_unit_id === 4) {
                hourly_rate = undefined;

            // Yearly Rate
            } else if (rate_unit_id === 5) {
                hourly_rate = undefined;

            // Unused for now Rate
            } else if (rate_unit_id === 6) {
                hourly_rate = undefined;

            // Unused for now Rate
            } else if (rate_unit_id === 7) {
                hourly_rate = undefined;

            // Unused for now Rate
            } else if (rate_unit_id === 8) {
                hourly_rate = undefined;

            // Flat Rate
            } else if (rate_unit_id === 9) {
                hourly_rate = undefined;

            // Piece Rate
            } else if (rate_unit_id === 10) {
                hourly_rate = undefined;

            } else {
                // console.log('No hourly rate calculated because no rule matched');
                this.rateFieldDisabled = false;
                return false;
            }

            if (hourly_rate) {
                // Canadians expect vacation pay to be part of the day/weekly rate
                let result = parseFloat(hourly_rate);
                if (this.isCanada && parseInt(this.assignment.rate_unit_id) !== 1 && (this.assignment.metadata || {}).includeVacation === true) {
                    result = result / (1 + parseFloat(this.defaultCanadaVacationPay))
                }
                this.assignment.hourly_rate = result.toFixed(4);

            } else {
                // console.log('No hourly rate calculated. Rate Unit: ' + rate_unit_id);
                // console.log(rate_unit_id);
                this.assignment.hourly_rate = '';
            }
            await this.checkMinWage();
            if (this.scale && this.assignment.hourly_rate && parseFloat(this.assignment.hourly_rate).toFixed(4) == parseFloat(this.scale).toFixed(4)) {
                this.assignment.is_paid_scale = true;
            }
            else {
                this.assignment.is_paid_scale = false;
            }
            this.rateFieldDisabled = false;
        },

        // Retreive Minimum wage data based on the available factors.
        async checkMinWage(setToScale=true) {
            this.scaleMessage = '';
            // California Minimum wage applies to residents working out of state as well
            let unionJurisdiction;
            if (this.union && this.assignment.job_title_id && this.assignment.union_hired_from_id == 79) {
                unionJurisdiction = 1;
            } else {
                unionJurisdiction = this.mainLocation.union_jurisdiction_id || null;
            }

            // Is this from complete?  If so, the value should be the assignment id lookup the employee
            var options = {
                location_id: this.assignment.location_id,
                agreement_id: this.assignment.agreement_id,
                job_title_id: this.assignment.job_title_id,
                legislative_type_id: this.assignment.legislative_type_id,
                resident_state_id: this.assignment.resident_state_id,
                union_local_id: this.assignment.union_local_id,
                union_jurisdiction_id: unionJurisdiction,
                union_schedule_id: this.assignment.union_schedule_id,
                union_hired_from_id: this.assignment.union_hired_from_id
            };

            if (! this.assignment.hourly_rate) {
                options.rate_unit_id = this.assignment.rate_unit_id;
                options.rate = this.assignment.rate;
            } else {
                options.rate_unit_id = 1;
                options.rate = this.assignment.hourly_rate;
            }

            // Send data to backend to determine if below minimum wage or scale
            const minWageResponse = await this.oasisApi.post('/minimumWage', options);
            if (minWageResponse && minWageResponse.data) {
                this.minWage = minWageResponse.data;
            } else {
                // If there is no response, there is a backend error.  Stop the user from saving for now.
                $("input[name='rate']").addClass('form-error')
                return true;
            }

            // Check scale first if available
            if (this.minWage.scale) {
                // Figure out which one
                if (this.scaleType === 'distant') this.scale = this.minWage.scale.scale_distant || this.minWage.scale.scale || null;
                else if (this.scaleType === 'productionCity') this.scale = this.minWage.scale.scale_production_cities || this.minWage.scale.scale || null;
                else if (this.scaleType === 'studio') this.scale = this.minWage.scale.scale || null;
                else this.scale = this.minWage.scale.scale || this.minWage.scale.scale || null;

                // Set Scale rate to hourly for ProPay
                const onCall = this.assignment.flsa_type_id === 2;
                const unionJobRuleMx = this.unionJobRules.find((rule) => rule.id === this.assignment.union_ruleset_id);
                // Get the scale for the current rate unit
                this.scaleMessage = this.calcAdjustedScale();

                if (setToScale && this.assignment.is_paid_scale === true && this.scale && this.scaleMessage) {
                    // Allow for day and weekly rates to be slightly above or just below the adjusted scale, e.g.
                    // if the day rate calculates to 499.9951 or 500.0001, allow 500.00.
                    if (parseInt(this.assignment.rate_unit_id) === 1) {
                        this.assignment.rate = parseFloat(this.scaleMessage).toFixed(4);
                    } else if (this.assignment.rate && this.assignment.rate.toString().includes('.') && this.assignment.rate.toString().split('.')[1].length === 4) {
                        this.assignment.rate = parseFloat(this.scaleMessage).toFixed(4);
                    } else if (parseInt(this.assignment.rate_unit_id) === 2 || parseInt(this.assignment.rate_unit_id) === 3) {
                        this.assignment.rate = parseFloat(this.scaleMessage).toFixed(2);
                    }
                    this.assignment.hourly_rate = parseFloat(this.scale).toFixed(4);
                    $("input[name='rate']").addClass('form-change');
                    if (this.minWage.isBelow) await this.checkMinWage();
                }

                this.assignment.scale_rate = onCall ? (this.scale_rate / (this.minimumGuarantee || 60)) : this.scale;
                this.assignment.scale_stn = this.minWage.scale.subject_to_negotiation;

                if (onCall && parseFloat(parseFloat(this.scale).toFixed(4)) <= parseFloat(parseFloat(this.assignment.rate).toFixed(4))) {
                    // console.log('on call weekly');
                    this.minWage.isBelowScale = true;
                } else if (parseFloat(parseFloat(this.scale).toFixed(4)) > parseFloat(parseFloat(this.assignment.hourly_rate || this.assignment.rate).toFixed(4))) {
                    // console.log('Below scale: ' + this.assignment.hourly_rate + ' ' + this.scale);
                    this.minWage.isBelowScale = true;
                } else {
                    this.minWage.isBelowScale = false;
                }
            } else {
                this.minWage.isBelowScale = false;
            }

            // Now check min wage
            if (this.minWage.isBelow === true || this.minWage.isBelowScale === true) {
                $("input[name='rate']").addClass('form-error')
                return true; // True = below minwage/scale
            } else {
                $("input[name='rate']").removeClass('form-error')
                return false; // false = above minwage/scale
            }
        },

        calcAdjustedScale() {
            if (!this.scale) return;

            // Load OT rules
            let otRules;
            if (this.currentOtRules) {
                otRules = this.currentOtRules;
            } else {
                // console.log('No OT Rules');
                return;
            }

            // Set defaults
            let hours_per_day = (this.assignment.guaranteed_hours_unit_id == 8) ? parseInt(this.assignment.guaranteed_hours) : null;
            let hours_per_week = (this.assignment.guaranteed_hours_unit_id == 9) ? (parseInt(this.assignment.guaranteed_hours) || 40) : 40;
            let minimumGuarantee = parseFloat(this.minimumGuarantee || 0);
            if (!hours_per_day && hours_per_week >= 40) {
                hours_per_day = hours_per_week / 5;
            }
            // console.log(hours_per_day, minimumGuarantee)
            if (minimumGuarantee && minimumGuarantee >= 24 && (minimumGuarantee / 5) > hours_per_day) {
                hours_per_day = minimumGuarantee / 5;
            } else if (minimumGuarantee && minimumGuarantee < 24 && minimumGuarantee > hours_per_day) {
                hours_per_day = minimumGuarantee;
            }
            const rate_unit_id = parseInt (this.assignment.rate_unit_id);

            // Lookup OT rules or use default
            let straight  = (otRules[0]) ? otRules[0] : {"multiplier":1,"hourStart":0,"hourEnd":8}; 
            let overtime1 = (otRules[1]) ? otRules[1] : {"multiplier":0,"hourStart":0,"hourEnd":0}; 
            let overtime2 = (otRules[2]) ? otRules[2] : {"multiplier":0,"hourStart":0,"hourEnd":0}; 
            let overtime3 = (otRules[3]) ? otRules[3] : {"multiplier":0,"hourStart":0,"hourEnd":0}; 
            let overtime4 = (otRules[4]) ? otRules[4] : {"multiplier":0,"hourStart":0,"hourEnd":0}; 

            let result, st, ot1, ot2, ot3, ot4, ot1_rate, ot2_rate, ot3_rate, ot4_rate;
            ot1_rate = overtime1.multiplier;
            ot2_rate = overtime2.multiplier;
            ot3_rate = overtime3.multiplier;
            ot4_rate = overtime4.multiplier;

            if (overtime4.hourStart && hours_per_day > overtime4.hourStart) {
                // console.log ('Greater than ot4 threshold');
                ot4 = hours_per_day - overtime3.hourStart;
                ot3 = hours_per_day - overtime3.hourStart;
                ot2 = overtime2.hourEnd - overtime2.hourStart;
                ot1 = overtime1.hourEnd - overtime1.hourStart;
                st = straight.hourEnd;
            } else if (overtime3.hourStart && hours_per_day > overtime3.hourStart) {
                // console.log ('Greater than ot3 threshold');
                ot4 = 0;
                ot3 = hours_per_day - overtime3.hourStart;
                ot2 = overtime2.hourEnd - overtime2.hourStart;
                ot1 = overtime1.hourEnd - overtime1.hourStart;
                st = straight.hourEnd;
            } else if (overtime2.hourStart && hours_per_day > overtime2.hourStart) {
                // console.log ('Greater than ot2 threshold');
                ot4 = 0;
                ot3 = 0;
                ot2 = hours_per_day - overtime2.hourStart;
                ot1 = overtime1.hourEnd - overtime1.hourStart;
                st = straight.hourEnd;
            } else if (overtime1.hourStart && hours_per_day > overtime1.hourStart) {
                // console.log ('Greater than ot1 threshold');
                ot4 = 0;
                ot3 = 0;
                ot2 = 0;
                ot1 = hours_per_day - overtime1.hourStart;
                st = straight.hourEnd;
            } else {
                // console.log ('Straight Time Only');
                ot4 = 0;
                ot3 = 0;
                ot2 = 0;
                ot1 = 0;
                // Allow min calls/guarantees of less than 8 hours only for union
                st = (!this.union && hours_per_day < 8) ? 8 : (hours_per_day || 8);
            }
            // console.log(st, ot1, ot2, ot3, ot4, ot1_rate, ot2_rate, ot3_rate, ot4_rate);

            // Return scale for the unit of pay (assuming scale is always hourly)
            if ((!this.scale || isNaN(this.scale)) && parseInt(this.assignment.scale_stn) > 0) {
                return 'STN';

            // Hourly
            } else if (rate_unit_id === 1) {
                result = this.scale;

            // Day Rate
            } else if (rate_unit_id === 2) {
                result = this.scale*1 * (st + ot1_rate*ot1 + ot2_rate*ot2 + ot3_rate*ot3 + ot4_rate*ot4);

            // Weekly Rate
            } else if (rate_unit_id === 3) {
                result = (this.scale*1) * (5 * (st + ot1_rate*ot1 + ot2_rate*ot2 + ot3_rate*ot3 + ot4_rate*ot4));

            } else {
                // console.log('No scale');
                return '';
            }

            return parseFloat(result).toFixed(4);
        },

        sendStart() {
            let options = { sendStart: true };
            this.addStart(options);
        },

        async addStart(options) {
            // Quick check
            await this.calcEffectiveHourlyRate();
            if (! this.checkForm()) return false;

            let assignmentId = this.assignment.id;
            let data = {};

            // update custom fields. TODO Do we need to add to assignmentChanged?
            this.updateCustomForms();

            // availableAssignments means that this is an edit (not create) view. TODO make a new API endpoint
            if (typeof availableAssignments == undefined && assignmentId) {
                this.createDialog({ "title": "Warning", "body": 'Cannot update an existing start', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            } else if (assignmentId) {
                var type = 'patch';
                let assignmentChanged = {},
                    employeeChanged = {},
                    agentChanged = {};

                $("#employeeForm .form-change").each(function(ind,el) { employeeChanged[el.name] = el.value });
                $("#agentForm .form-change").each(function(ind,el) { agentChanged[el.name] = el.value });
                $("#job1Form .form-change").each(function(ind,el) { assignmentChanged[el.name] = el.value });
                this.changes.assignment.forEach((field) => {
                    assignmentChanged[field] = this.assignment[field];
                })

                // Add changed fields that did not get highlighted.
                if (this.assignmentOriginal) {
                    for (const key in this.assignmentOriginal) {
                        const skipKeys = ['id', 'status', 'hash', 'metadata', 'custom_forms', 'custom_form_fields', 'custom_form_employer_fields'];
                        if (skipKeys.includes(key)) { continue; }
                        if (typeof this.assignment[key] === 'object') { continue; }
                        if (this.assignment[key] != this.assignmentOriginal[key] && !assignmentChanged[key]) {
                            $("input[name="+key+"]").addClass('form-change')
                            assignmentChanged[key] = this.assignment[key];
                        }
                    }
                }

                // Check employee changes
                this.changes.employee.forEach((field) => {
                    employeeChanged[field] = this.employee[field];
                })
                if (assignmentChanged.start_date) assignmentChanged.start_date = DateTime.fromFormat(assignmentChanged.start_date, this.format).toFormat('MM/dd/yyyy');
                if (assignmentChanged.term_date) assignmentChanged.term_date = DateTime.fromFormat(assignmentChanged.term_date, this.format).toFormat('MM/dd/yyyy');
                // hidden so need to manually set
                employeeChanged.special_type = this.employee.special_type;
                assignmentChanged.rate_comment = this.assignment.rate_comment;
                assignmentChanged.loanout_status = this.assignment.loanout_status;
                assignmentChanged.hourly_rate = this.assignment.hourly_rate;
                assignmentChanged.rule_collection_id = this.assignment.rule_collection_id;
                assignmentChanged.certification_type_id = this.assignment.certification_type_id;
                assignmentChanged.custom_forms = this.assignment.custom_forms;
                assignmentChanged.custom_form_fields = this.assignment.custom_form_fields;
                assignmentChanged.custom_form_employer_fields = this.assignment.custom_form_employer_fields;
                assignmentChanged.legislative_type_id = this.assignment.legislative_type_id;

                // is_paid_scale is auto-set, so assume that we always need to save it
                assignmentChanged.is_paid_scale = this.assignment.is_paid_scale ? "1" : "0";

                // Start changed so need to start process over
                if (this.keyFieldsChanged) {
                    assignmentChanged.editCompletedStart = true;
                    assignmentChanged.employerMessage = this.employerMessage;
                }

                // TODO use vuex or find better way of handling hidden fields than using the DOM
                if (assignmentChanged.job_title) {
                    assignmentChanged.job_title_id = this.assignment.job_title_id;
                    assignmentChanged.job_title_override = this.assignment.job_title_override;
                }

                if (assignmentChanged.budget_code) {
                    assignmentChanged.fringe_code = this.assignment.fringe_code;
                }

                if (assignmentChanged.pw_budget_code) {
                    assignmentChanged.pw_fringe_code = this.assignment.pw_fringe_code;
                }

                if (assignmentChanged.union_local_id || (this.union && assignmentChanged.legislative_type_id)) {
                    assignmentChanged.union_flsa_type_id = this.assignment.union_flsa_type_id;
                    assignmentChanged.flsa_type_id = this.assignment.flsa_type_id;
                    assignmentChanged.union_ruleset_id = this.assignment.union_ruleset_id;
                    assignmentChanged.union_local_id = this.assignment.union_local_id;
                    assignmentChanged.union_hired_from_id = this.assignment.union_hired_from_id;
                    assignmentChanged.agreement_id = this.assignment.agreement_id;
                    assignmentChanged.union_schedule_id = this.assignment.union_schedule_id;
                    assignmentChanged.union_on_prod_id = this.assignment.union_on_prod_id;
                    assignmentChanged.union_rule_overrides = this.assignment.union_rule_overrides;
                    assignmentChanged.occ_code = this.assignment.occ_code;
                    assignmentChanged.scale_rate = this.assignment.scale_rate;
                }

                data = {
                    // employee: this.employee,
                    employee: employeeChanged,
                    employeeFull: this.employee,
                    assignment: assignmentChanged,
                    assignmentfull: this.assignment,
                    agentData: agentChanged,
                    metadata: this.assignment.metadata,
                };
            } else {
                var type = 'post';
                this.updateCustomForms();
                data = {
                    employee: this.employee,
                    assignment: this.assignment,
                    agentData: this.employee.special_type_properties,
                };
            }
            if (options.approve && options.approve === true) {
                // console.log ('Approve');
                data.approve = true;
            }
            if (options.sendStart && options.sendStart === true) {
                // console.log ('sendStart');
                data.sendStart = true;
            }

            this.waiting = true;
            this.oasisApi[type]('/assignments/' + assignmentId, data)
                .then(response => {
                    if (response.status == 200){
                        this.modified = false;
                        this.assignment.status = response.data.status;
                        if (!this.assignment.id) this.assignment.id = response.data.id;
                        if (!this.assignment.hash) this.assignment.hash = response.data.hash;
                        this.createDialog({ "title": "Success", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else if (response.status == 201) {
                        this.modified = false;
                        if (typeof response.data === 'object') {
                            this.assignment.employee_id = response.data.employee_id;
                            this.assignment.id = response.data.id;
                            this.assignment.hash = response.data.hash;
                            this.assignment.status = response.data.status;
                            this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else {
                            this.createDialog({ "title": "Success", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("#job1Form input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert (error);
                    this.waiting = false;
                })
            ;

        },

        // For new starts, check for dupes by tin or email
        async checkAssignment() {
            this.setModified();

            let query = {
                entity_id: this.entityId,
            };
            let message;

            if (this.employee.tin && this.employee.tin.length > 8) {
                query.tin = this.employee.tin;
                message = ` SSN/Tax ID ending in ${this.employee.tin.slice(-4)}`;
            } else if (this.employee.email) {
                query.email = this.employee.email;
                message = ` e-mail "${this.employee.email}"`;
            }

            if (Object.keys(query).length < 2) {
                this.createDialog({ "title": "Error", "body": 'Please enter an email or SSN/tax id', "buttonNo": false, "buttonYesLabel": "OK" });
                this.loading = false;
                return false;
            }

            let queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');
            this.loading = true;
            const response = await this.oasisApi.getAllPages('/relatedAssignments?' + queryString);
            // console.log(query, queryString, response);
            this.loading = false;

            const assignment = (response && response.data && response.data.count && response.data.count > 0) ? response.data.results[0] : null;
            if (assignment) {
                // console.log(assignment);
                this.createDialog({ "title": "Warning", "body": `There is an existing start with the ${message}.  Select "Edit" to modify the existing start or "Create New Start" for this employee.`,
                    "buttonYesLabel": "View", "buttonYesAction": () => { this.waiting = true; window.location.href = '/oasis/starts/edit/' + assignment.hash; },
                    "buttonNoLabel": 'Create New Start',
                    "buttonNo": true,
                    "button3Label": 'Cancel',
                    "button3Action": () => { app.resetStart(); },
                    "button3": true,
                });
            } else {
                return true;
            }
        },

        // Prevent adding a new employee to an existing employee
        unlockEmployee() {
            const scope = this;
            this.createDialog({ "title": "Warning", "body": 'Please Unlock to correct information, not to create a new start.', "buttonNoLabel": "Close", "buttonYesLabel": "Unlock", "buttonYesAction": () => { scope.empSet = false } });
        },

        // Retrieve link to start PDFs
        printStart() {
            this.waiting = true;
            if (this.assignment.id) {
                this.oasisApi.get('/printStart/' + this.assignment.id)
                    .then(response => {
                        if (response.status == 200 ) {
                            this.createDialog({ "title": "Start Paperwork", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else if (response.status == 400) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        }
                        this.waiting = false;
                    })
                    .catch(error => {
                        this.waiting = false;
                        // console.log('error: '); console.log(error); 
                    });
            }
            else {
                this.createDialog({ "title": "Warning", "body": "Start is not complete.  Please save first.", "buttonNo": false, "buttonYesLabel": "OK" });
                this.waiting = false;
            }
        },

        // Function to set the initial state for custom forms.
        populateCustomForms() {
            if (! this.customForms || this.customForms.length === 0) return false;
            if (this.type === 'edit') {
                this.updateCustomForms();
                return;
            }
            // this.modified = true;
            const firstRun = (this.selectedCustomForms.length > 0) ? false : true;
            let overrides = [];

            this.customForms.forEach( ( { id, name, selected, properties } ) => {
                /* We're going to select/deselect here by properties (location, department, or whatever is available on the assignment object) of the custom form.
                 * The logic is this, if it is selected by default, it will de-select if the properties don't match; otherwise,
                 * if the form is not selected by default, it will not select the form.
                 * The result will be pushed to this.selectedCustomForms
                */

                const props = properties;

                let isSelected = (firstRun) ? -1 : this.selectedCustomForms.indexOf(id),
                    isRequired = props.required,
                    isLoanout = undefined,  // If still undefined, means we did not find a match to test.
                    isUnion = undefined,  // If still undefined, means we did not find a match to test.
                    isLocation = undefined,  // If still undefined, means we did not find a match to test.
                    isFlsaMatch = undefined,
                    isAgent = undefined,  // If still undefined, means we did not find a match to test.
                    isDepartment = undefined,  // If still undefined, means we did not find a match to test.
                    isRateUnit = undefined,  // If still undefined, means we did not find a match to test.
                    isRuleCollection = undefined,  // If still undefined, means we did not find a match to test.
                    isJobMatch = true,  // If still undefined, means we did not find a match to test.
                    isMatch = undefined,  // If still undefined, means we did not find a match to test.
                    addSelection = undefined,
                    removeSelection = undefined
                ;

                // console.log(name);
                // console.log(props);
                // Loanout
                if (props.hasOwnProperty('nonloanout_doc') === false) {
                    isLoanout = false;
                } else if (this.assignment.loanout_status == 0 && props.nonloanout_doc == true) {
                    isLoanout = true;
                } else if (this.assignment.loanout_status == 0 && props.nonloanout_doc == false) {
                    isLoanout = false;
                } else if (this.assignment.loanout_status == 1 && props.loanout_doc == true) {
                    isLoanout = true;
                } else if (this.assignment.loanout_status == 1 && props.loanout_doc == false) {
                    isLoanout = false;
                }

                // Special
                if (props.hasOwnProperty('agent_doc') === false) {
                    isAgent = undefined;
                } else if (this.employee.show_agent == 1 && props.agent_doc == true) {
                    isAgent = true;
                }

                // Union
                if (props.hasOwnProperty('union_doc') === false) {
                    isUnion = false;

                // If non-union
                } else if (this.assignment.flsa_type_id != 3 && props.nonunion_doc === true) {
                    // console.log('non union, nonunion_doc = ' + props.nonunion_doc);
                    isUnion = true;

                } else if (this.assignment.flsa_type_id != 3 && props.nonunion_doc === false) {
                    // console.log('non union, nonunion_doc = ' + props.nonunion_doc);
                    isUnion = false;

                // Non-union doc
                } else if (this.assignment.flsa_type_id == 3 && props.union_doc === false) {
                    // console.log('union, nonunion_doc = ' + props.union_doc);
                    isUnion = false;

                // Must be union if in this block
                } else if (this.assignment.flsa_type_id == 3 && props.union_doc === true) {
                    // console.log('union, nonunion_doc = ' + props.union_doc);
                    isUnion = true;

                    // Check for specific locals/agreements/jobs
                    let agreement_id = props.agreement_id || false;
                    let union_local_id = props.union_local_id || false;
                    let union_job_title_id = props.job_title_id || props.union_job_title_id || false;
                    let union_schedule_id = props.union_schedule_id || false;

                    if (agreement_id || union_local_id || union_job_title_id || union_schedule_id) {
                        if (agreement_id && this.isJson(agreement_id) && (Array.isArray(agreement_id) || Array.isArray(JSON.parse(agreement_id)))) {
                            // console.log('JSON');
                            const unionAgreements = Array.isArray(agreement_id) ? agreement_id : JSON.parse(agreement_id);
                            if (! unionAgreements.find( (id) => id == this.assignment.agreement_id)) {
                                // console.log('no agreement set' + agreement_id + ' ' + this.assignment.agreement_id);
                                isUnion= false;
                            }
                        } else if (agreement_id && agreement_id != this.assignment.agreement_id) {
                            // console.log('no agreement set' + agreement_id + ' ' + this.assignment.agreement_id);
                            isUnion = false;
                        }

                        if (union_local_id && this.isJson(union_local_id) && (Array.isArray(union_local_id) || Array.isArray(JSON.parse(union_local_id)))) {
                            // console.log('JSON');
                            const unionAgreements = Array.isArray(union_local_id) ? union_local_id : JSON.parse(union_local_id);
                            if (! unionAgreements.find( (id) => id == this.assignment.union_local_id)) {
                                // console.log('no union_local set' + union_local_id + ' ' + this.assignment.union_local_id);
                                isUnion = false;
                            }
                        } else if (union_local_id && union_local_id != this.assignment.union_local_id) {
                            // console.log('no union_local set' + union_local_id + ' ' + this.assignment.union_local_id);
                            isUnion = false;
                        }

                        if (union_job_title_id && this.isJson(union_job_title_id) && (Array.isArray(union_job_title_id) || Array.isArray(JSON.parse(union_job_title_id)))) {
                            // console.log('JSON');
                            const unionJobs = Array.isArray(union_job_title_id) ? union_job_title_id : JSON.parse(union_job_title_id);
                            if (! unionJobs.find( (id) => id == this.assignment.job_title_id)) {
                                // console.log('no jobtitle set' + union_job_title_id + ' ' + this.assignment.job_title_id);
                                isUnion = false;
                            }
                        } else if (union_job_title_id && union_job_title_id != this.assignment.job_title_id) {
                            // console.log('NOT JSON and no job match' + union_job_title_id + ' ' + this.assignment.job_title_id);
                            isUnion = false;
                        }

                        if (union_schedule_id && this.isJson(union_schedule_id) && (Array.isArray(union_schedule_id) || Array.isArray(JSON.parse(union_schedule_id)))) {
                            const unionSchedules = Array.isArray(union_schedule_id) ? union_schedule_id : JSON.parse(union_schedule_id);
                            // console.log('JSON');
                            if (! unionSchedules.find( (id) => id == this.assignment.union_schedule_id)) {
                                // console.log('no schedule set' + union_schedule_id + ' ' + this.assignment.union_schedule_id);
                                isUnion = false;
                            }
                        } else if (union_schedule_id && union_schedule_id != this.assignment.union_schedule_id) {
                            // console.log('NOT JSON and no schedule match' + union_schedule_id + ' ' + this.assignment.union_schedule_id);
                            isUnion = false;
                        }
                    }
                    // console.log('Union: ' + isUnion);
                    // console.log(agreement_id, union_local_id, union_job_title_id);
                }

                // Locations
                if (props.hasOwnProperty('locations') === true) {
                    // Need to manually set to false as undefined means no properties exist.
                    isLocation = false;

                    if (!props.locations) {
                        isLocation = undefined;
                    } else if (typeof props.locations === 'object') {
                        for (let label of Object.keys(props.locations)) {
                            // For new employees, look at default location state
                            if (label === 'mainLocationState' && !this.mainLocationState) {
                                const defaultLocationState = (this.projectLocations.find(({id}) => parseInt(id) === parseInt(this.entity.default_location_id)) || {}).state || null;
                                if (defaultLocationState == props.locations[label]) {
                                    // console.log('match main location state', label, defaultLocationState);
                                    isLocation = true;
                                }
                            } else if (label === 'defaultState' && this.mainLocation && (parseInt(this.mainLocation.state_id) === parseInt(props.locations[label]))) {
                                // console.log('match', label, props.locations[label], this.mainLocation.state_id, this.assignment.location_id);
                                isLocation = true;
                            } else {
                                // console.log('NOT matched location');
                            }
                        }
                    }
                }

                // FLSA Type
                if (props.hasOwnProperty('flsa_type_id') === true) {
                    // Need to manually set to false as undefined means no properties exist.
                    // console.log ('FLSA ')
                    isFlsaMatch = false;
                    if (props.hasOwnProperty('flsa_type_id') === true && props.flsa_type_id === null) {
                        // console.log ('FLSA Undefined')
                        isFlsaMatch = undefined;
                    } else if (props.hasOwnProperty('flsa_type_id') === true && this.assignment.flsa_type_id == props.flsa_type_id) {
                        // console.log ('FLSA Match ' + props.flsa_type_id)
                        isFlsaMatch = true;
                    }
                    // console.log (isFlsaMatch)
                }

                // Rate Unit Match Type
                if (props.hasOwnProperty('rate_unit_id') === true) {
                    // Need to manually set to false as undefined means no properties exist.
                    // console.log ('RateUnit ')
                    isRateUnit = false;
                    if (props.hasOwnProperty('rate_unit_id') === true && props.rate_unit_id === null) {
                        // console.log ('RateUnit Undefined')
                        isRateUnit = undefined;
                    } else if (props.hasOwnProperty('rate_unit_id') === true && this.assignment.rate_unit_id == props.rate_unit_id) {
                        // console.log ('RateUnit Match ' + props.rate_unit_id)
                        isRateUnit = true;
                    }
                }

                // Rule Collection Match Type
                if (props.hasOwnProperty('rule_collection_id') === true) {
                    // Need to manually set to false as undefined means no properties exist.
                    // console.log ('RuleCollection ')
                    isRuleCollection = false;
                    if (!props.rule_collection_id) {
                        // console.log ('RuleCollection Undefined')
                        isRuleCollection = undefined;
                    } else if (this.assignment.rule_collection_id == props.rule_collection_id) {
                        // console.log ('RuleCollection Match ' + props.rule_collection_id)
                        isRuleCollection = true;
                    }
                }

                // Departments
                if (props.hasOwnProperty('departments') === false) {
                    // do stuff here
                } else if (props.departments) {
                    // do stuff here
                }

                // Job title match
                if (props.hasOwnProperty('job_title_id') === true) {
                    // Need to manually set to false as undefined means no properties exist.
                    // console.log ('Job Title Match ')
                    isJobMatch = false;
                    const job_title_id = props.job_title_id || null;

                    if (job_title_id && this.isJson(job_title_id) && (Array.isArray(job_title_id) || Array.isArray(JSON.parse(job_title_id)))) {
                        const jobs = Array.isArray(job_title_id) ? job_title_id : JSON.parse(job_title_id);
                        if (jobs.find((id) => parseInt(id) === parseInt(this.assignment.job_title_id))) {
                            // console.log('jobtitle set ' + id + ' ' + this.assignment.job_title_id);
                            isJobMatch = true;
                        }
                    } else if (job_title_id && parseInt(job_title_id) === parseInt(this.assignment.job_title_id)) {
                        // console.log('NOT JSON and job match ' + job_title_id + ' ' + this.assignment.job_title_id);
                        isJobMatch  = true;
                    } else if (!job_title_id) {
                        // Incorrectly set property so let's not check for it.
                        isJobMatch = undefined;
                    }

                    // console.log (isJobMatch)
                }

                // Logic here  If all true, it's a match.  If any are false, no match.  If anything else, it's undefined and logic to handle that is later
                if (isLoanout === true && isUnion === true && isLocation === true && isFlsaMatch === true && isAgent === true && isRateUnit === true && isRuleCollection === true && isJobMatch === true) {
                    // console.log( 'True', isLoanout, isUnion, isLocation, isFlsaMatch, isAgent, isJobMatch);
                    isMatch = true;
                } else if (isLoanout === false || isUnion === false || isLocation === false || isFlsaMatch === false || isAgent === false || isRateUnit === false || isRuleCollection === false || isJobMatch === false) {
                    // console.log( 'False', isLoanout, isUnion, isLocation, isFlsaMatch, isAgent, isJobMatch);
                    isMatch = false;
                } else if (isLoanout === true || isUnion === true || isLocation === true || isFlsaMatch === true || isAgent === true || isRateUnit === true || isRuleCollection === true || isJobMatch === true) {
                    // console.log( isLoanout, isUnion, isLocation, isFlsaMatch, isAgent, isJobMatch);
                    isMatch = true;
                }

                // First run
                if (firstRun) {
                    if (isRequired && (isMatch === undefined || isMatch === true)) {
                        addSelection = true;
                        if (props.overrides && Array.isArray(props.overrides)) {
                            overrides = overrides.concat(props.overrides);
                        }
                    }
                } else {
                    // console.log ('subsequent run');
                    if (isMatch === undefined) {
                        // console.log (id + ' no match to test, leave selection alone ' + isSelected);
                    } else if (isRequired && isMatch === true) {
                        // console.log (id + ' matched, required, and selected ' + isSelected);
                        addSelection = true;
                        if (props.overrides && Array.isArray(props.overrides)) {
                            overrides = overrides.concat(props.overrides);
                        }
                    } else if (isMatch === false) {
                        // console.log (id + ' no match and de-selected ' + isSelected);
                        removeSelection = true;
                    }
                }

                if (addSelection && (isSelected < 0)) {
                    this.selectedCustomForms.push(id);
                    this.updateCustomForms();
                } else if (removeSelection && isSelected >= 0) {
                    // console.log ('Removing ' + id)
                    this.selectedCustomForms.splice(isSelected, 1)
                }
            });

            // Remove overrides
            overrides = [ ...new Set(overrides) ];
            if (overrides.length > 0) {
                this.selectedCustomForms = this.selectedCustomForms.filter( (form) => !overrides.includes(parseInt(form)));
                this.updateCustomForms();
            }
        },

        // Function to load the state for custom forms.
        // not used
        parseCustomForms() {
            if (! this.customForms || this.customForms.length === 0) return false;
            if (! this.assignment.custom_forms || this.assignment.custom_forms.length === 0) {
                this.selectedCustomForms = [];
            } else {
                this.selectedCustomForms.forEach( selected => {
                    this.customForms.filter( ( { id } ) => { if (id == selected) this.selectedCustomForms.push(id); })
                });
            }
        },

        // Function to modify custom forms.  Basically, add fields only if new custom forms are selected.  Don't remove as they just won't print...  TODO?
        updateCustomForms() {
            this.assignment.custom_forms = this.selectedCustomForms;

            // No custom forms, no need to update.  // for now remove fields too.  see later TODO on inactive/active
            if (! this.customForms || this.customForms.length === 0) {
                this.assignment.custom_form_fields = {};
                this.assignment.custom_form_employer_fields = {};
                return false;
            } else if (! this.selectedCustomForms || this.selectedCustomForms.length === 0) {
                this.assignment.custom_form_fields = {};
                this.assignment.custom_form_employer_fields = {};
                return false;
            }

            if (! this.assignment.custom_form_fields) {
                this.assignment.custom_form_fields = {};
            }
            if (! this.assignment.custom_form_employer_fields) {
                this.assignment.custom_form_employer_fields = {};
            }

            // Now go through each form's fields and add to the assignment
            for (let i = 0; i < this.selectedCustomForms.length; i++) {
                let form = this.customForms.find( ( { id } ) => id === this.selectedCustomForms[i] );
                if (!form || !form.fields || form.fields.length === 0) {
                    continue;
                }

                // now make sure the fields exist
                for (let i = 0; i < form.fields.length; i++) {
                    let formField = form.fields[i];
                    let userRole = formField.role || false;
                    // Create if it doesn't exist already.
                    if (formField.status > 0 && userRole === 'employer' && ! this.assignment.custom_form_employer_fields[formField.field]) {
                        this.assignment.custom_form_employer_fields[formField.field] = { id: formField.id, name: formField.field, label: formField.name, type:formField.type, required: formField.required, length: formField.length, sortOrder: formField.sort_order, role: formField.role, documentId: formField.custom_document_id, value: formField.default_value || null }

                    // Assume employee role for now if not employer
                    } else if (formField.status > 0 && userRole === 'employee' && ! this.assignment.custom_form_fields[formField.field]) {
                        this.assignment.custom_form_fields[formField.field] = { id: formField.id, name: formField.field, label: formField.name, type:formField.type, required: formField.required, length: formField.length, sortOrder: formField.sort_order, role: formField.role, documentId: formField.custom_document_id, value: null }
                    } else {
                        // Nothing
                    }
                }
            }
        },

        unlockStart () {
            this.empLocked = false;
        },

        async convertToHourly () {
            this.assignment.rate = this.assignment.hourly_rate;
            this.assignment.rate_unit_id = 1;
            this.calcEffectiveHourlyRate();
        },

        // Load I9
        loadI9 (assignment) {
            if (!assignment) {
                return false;
            } else if (this.assignment.list_a_type_id || this.assignment.list_b_type_id) {
                return false;
            }

            this.oasisApi.get('/assignments/' + assignment.hash + '/previousI9')
                .then(response => {
                    // console.log('Loaded I9');
                    // console.log(response);
                    if (response.status === 200 && response.data) {
                        for(const i in response.data) {
                            this.assignment[i] = response.data[i];
                        }
                        this.assignment.is_rehire = true;
                    }
                })
                .catch(error => {
                    console.log(error);
                    return false;
                });
        },

        populateAgentProperties () {
            if (this.employee.show_agent == 0) {
                if (this.assignment.agent_fee) this.assignment.agent_fee = '';
                this.changes.assignment.push('agent_fee');
                this.employee.special_type = 0;
            }
            if (this.employee.show_agent == 1 && this.employee.special_type !== '0') {
                this.employee.special_type = 1;
            }
            this.populateCustomForms();
        },

        editCompletedStart () {
            // console.log('Editing Completed Start');
            this.editingCompletedStart = true;
            this.preEditAssignment = JSON.parse(JSON.stringify(this.assignment));
            this.preEditAllowances = this.totalAllowances;
            this.preEditCaps = this.capTotal;
            // console.log('preEditAllowances ' + this.preEditAllowances);
            // console.log('preEditCaps ' + this.preEditCaps);

            this.editCompletedStartModal = false;
            if (! this.assignment.hash) {
                this.createDialog({ "title": "Error", "body": 'This start cannot be edited.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            this.empLocked = false;

            return true;
        },

        // Probably good forMixins!

        // Generic test function
        log(value) {
            console.log('Logging:');
            console.log(value);
        },

        // For creating starts, set default overtime.  TODO: location
        setDefaults (force=false) {
            // console.log ('Setting Defaults');
            if (force === true || ! this.assignment.rule_collection_id) this.assignment.rule_collection_id = this.entity.default_overtime_id || 1;
            if (! this.assignment.department_id) this.assignment.department_id = (this.departments[0] || {}).id || '';

            if (!this.assignment.metadata) {
                this.assignment.metadata = {};
            }
            if (this.isCanada && !this.assignment.metadata.includeVacation) {
                this.assignment.metadata.includeVacation = true;
            }

            if (!this.assignment.pd_rate_unit_id) this.assignment.pd_rate_unit_id = this.defaultRateUnitPerDiem;
            if (!this.assignment.lodging_rate_unit_id) this.assignment.lodging_rate_unit_id = this.defaultRateUnitLodging;
            if (!this.assignment.kit_rate_unit_id) this.assignment.kit_rate_unit_id = this.defaultRateUnitKit;
            if (!this.assignment.car_rate_unit_id) this.assignment.car_rate_unit_id = this.defaultRateUnitCar;
            if (!this.assignment.phone_rate_unit_id) this.assignment.phone_rate_unit_id = this.defaultRateUnitPhone;
        },

        isJson(string, log=false) {
            if (log) console.log(string)

            if (typeof string === 'object') {
                if (log) console.log('JSON!')
                return true;
            }

            try {
                JSON.parse(string);
            } catch (e) {
                if (log) console.log('Not JSON. Could not Parse')
                return false;
            }
            
            if (typeof JSON.parse(string) === 'object') {
                if (log) console.log('Parsed JSON!')
                return true;
            } else {
                if (log) console.log('Not JSON. Not Object')
                return false;
            }
        },

        setModified() {
            this.modified = true;
        },

        highlightChange( {target} ) {
            // console.log ($(target));
            if (this.existingStart === true) {
                $(target).removeClass('form-missing');
                $(target).addClass('form-change');
            }

            // do some light validation to check if an `.amount` field contains invalid characters.
            if ($(target).hasClass('amount') && $(target).val() && $(target).val().match(/[^0-9\.]/g, '')) {
                $(target).addClass("form-error");
            } else if ($(target).hasClass('amount') && $(target).hasClass('form-error')) {
                $(target).removeClass("form-error");
            }

            this.setModified();
            if (this.editingCompletedStart) {
                if (this.checkKeyFields()) {
                    this.errorMessages = 'Some key fields have been changed.  Please review before saving.';
                }
            }
            return;
        },

        // Look for changes in key fields.
        async checkKeyFields() {
            let keyFieldsChanged = false;
            if (this.editingCompletedStart) {
                const keyFields = [ 'employee_id', 'rate_unit_id', 'legislative_type_id', 'flsa_type_id', 'job_title_id', 'union_local_id', 'agreement_id' ];
                // Allow changes that benefit the employee, e.g. raises or more allowances
                const keyFieldsIncreaseOk = [ 'rate', 'hourly_rate', 'scale_rate' ];
                const keyFieldsDecreaseOk = [ 'guaranteed_hours', 'guaranteed_hours_6th', 'guaranteed_hours_7th' ];

                // Check for rule collection changes
                if (this.assignment.rule_collection_id !== this.preEditAssignment.rule_collection_id) {
                    await this.calcEffectiveHourlyRate();
                }

                // Total allowances should be the same or more than before
                if (this.totalAllowances < this.preEditAllowances) {
                    keyFieldsChanged = true;
                    // console.log('totalAllowances changed from ' + this.preEditAllowances + ' to ' + this.totalAllowances);
                }

                // Total caps should be the same or more than before
                if (this.capTotal < this.preEditCaps) {
                    keyFieldsChanged = true;
                    // console.log('totalCaps changed from ' + this.preEditCaps + ' to ' + this.capTotal);
                }

                // Look for any change to the values of key fields on the assignment
                for (const key of keyFields) {
                    // console.log(key + ' ' + this.assignment[key] + ' vs ' + this.preEditAssignment[key]);
                    if (this.assignment[key] !== this.preEditAssignment[key]) {
                        keyFieldsChanged = true;
                        // console.log(key + ' changed from ' + this.preEditAssignment[key] + ' to ' + this.assignment[key]);
                        break;
                    }
                }

                // Allow for increases in key fields that benefit the employee
                for (const key of keyFieldsIncreaseOk) {
                    // console.log(key + ' Checking increase ' + this.assignment[key] + ' vs ' + this.preEditAssignment[key]);
                    if (this.assignment[key] && !this.preEditAssignment[key]) {
                        // OK?
                    } else if (parseFloat(this.assignment[key]) < parseFloat(this.preEditAssignment[key])) {
                        keyFieldsChanged = true;
                        // console.log(key + ' changed from ' + this.preEditAssignment[key] + ' to ' + this.assignment[key]);
                        break;
                    }
                }

                // Allow for decreases in key fields that benefit the employee, e.g. lowering the expected
                for (const key of keyFieldsDecreaseOk) {
                    // console.log(key + ' Checking decrease ' + this.assignment[key] + ' vs ' + this.preEditAssignment[key]);
                    if (this.assignment[key] && !this.preEditAssignment[key]) {
                        // OK?
                    } else if (!this.assignment[key] && this.preEditAssignment[key]) {
                        keyFieldsChanged = true;
                        // console.log(key + ' changed from ' + this.preEditAssignment[key] + ' to ' + this.assignment[key]);
                        break;
                    } else if (parseFloat(this.assignment[key]) > parseFloat(this.preEditAssignment[key])) {
                        keyFieldsChanged = true;
                        // console.log(key + ' changed from ' + this.preEditAssignment[key] + ' to ' + this.assignment[key]);
                        break;
                    }
                }

                // Show error message
                this.keyFieldsChanged = keyFieldsChanged;
                if (keyFieldsChanged) {
                    this.error_message = 'Some key fields have been changed.  The start will need to be re-approved.  Please review before saving.';
                    return true;
                } else {
                    this.error_message = '';
                    return false;
                }
            } else {
                this.keyFieldsChanged = false;
                this.error_message = '';
                return false;
            }
        },

        highlightCalendar(target, value) {
            this.assignment[target] = value;
            if (this.existingStart === true) {
                this.calendar[target]=true;
            }
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },

        cancelCurrent() {
            let url = '/oasis/welcome/dashboard';
            if (this.modified) {
                this.createDialog({ "title": "Are You Sure?", "body": "You may lose your work.  Proceed?",
                    "buttonYesAction": function () { window.location.href = url; },
                });
            } else {
                window.location.href = url;
            }
        },

        closeWindow() {
            if (window && window.opener) {
                if (this.modified) {
                    this.createDialog({ "title": "Are You Sure?", "body": "You may lose your work.  Proceed?",
                        "buttonYesAction": function () { window.close(); },
                    });
                } else {
                    window.close();
                }
            } else {
                this.cancelCurrent();
            }
        },

        leavePage(e) {
            if (app.modified == true){
                // console.log ('Modified');
                var confirmationMessage = 'This start has been modified. If you quit before saving, your changes will be lost.';

                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            } else {
                // console.log ('Not Modified');
                return undefined;
            }
        },

        drawSignatureLine() {
            var ratio =  Math.max(window.devicePixelRatio || 1, 1);
            this.canvas.width = this.canvas.offsetWidth * ratio;
            this.canvas.height = this.canvas.offsetHeight * ratio;
            this.canvas.getContext("2d").scale(ratio, ratio);
            this.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
        },

        async loadProjectLocations() {
            const responseLocations = await this.oasisApi.get('/projectlocations')
            this.projectLocations = responseLocations.data;
        },

        async loadMinResources() {
            const responseEntities = await this.oasisApi.get('/entities')
            this.entity = responseEntities.data;
            if ( (this.entity.post_start_date && this.entity.post_end_date ) || (this.entity.prep_start_date && this.entity.prep_end_date) ) this.hasPrepWrap = true;
            this.harassmentCertification = parseInt((this.entity || {}).certification_enabled || 0) > 0 ? true : false; // false = do not require
            if (responseEntities.data.hasOwnProperty('other_properties') && responseEntities.data.other_properties) {
                const data = typeof responseEntities.data.other_properties === 'string' && this.isJson(responseEntities.data.other_properties) ? JSON.parse(responseEntities.data.other_properties) : responseEntities.data.other_properties;
                this.allowedUnionRuleCollections = data.allowedUnionRuleCollections || false; 
                this.allowedNonUnionRuleCollections = data.allowedNonUnionRuleCollections || false; 
                this.disableLoanouts = data.disableLoanouts || false; 
                this.enableLoanoutsEmployee = data.enableLoanoutsEmployee || false;
                this.companyHarassmentSupCertificateId = data.companyHarassmentSupCertificateId || null; // null = do not require
                this.companyHarassmentCertificateId = data.companyHarassmentCertificateId || null; // null = do not require
                this.enableWorkDay = data.enableWorkDay || false;
                if (data.defaultCurrency) {
                    this.assignment.currency_id = data.defaultCurrency;
                }
                if (data.defaultLegislativeType) {
                    this.assignment.legislative_type_id = data.defaultLegislativeType;
                }
                if (data.defaultRateUnits) {
                    this.defaultRateUnits = data.defaultRateUnits || {};
                }
            }
            await this.loadProjectLocations();
            const defaultLoc = this.projectLocations.find((loc) => loc.default == 1);
            this.updateLocationSettings(defaultLoc);  // Sets project location 

            const responseDepartments = await this.oasisApi.get('/departments')
            if (responseDepartments && responseDepartments.data && responseDepartments.data.results) this.departments = responseDepartments.data.results;

            // check chart of accounts
            let now = new Date();
            let currentTime = now.getTime();
            let COAObj = JSON.parse(window.localStorage.getItem(entityId + '#'));
            // If COA data is not loaded for unexpected reason in dashboard, will get COA data just in case here.
            if (!COAObj || (COAObj && COAObj.isLoaded == false)) {
                await this.getProbooksResources(currentTime);
                COAObj = JSON.parse(window.localStorage.getItem(entityId + '#'));
            }
            this.probooksAccounts =  COAObj.accounts || [];
            this.probooksFreeFields = COAObj.freeFields || [];
            this.probooksSeries = COAObj.series || [];
            this.probooksLocations = COAObj.locations || [];
            this.probooksSets = COAObj.sets || [];
            this.probooksProjects = COAObj.projects || [];

            if (!this.probooksAccounts || !this.probooksFreeFields || !this.probooksSeries || !this.probooksLocations || !this.probooksSets) {
                // data is not loaded in dashboard. do nothing.
                // ex) data is loaded, It will be return [](empty) - true. but data is not loaded, It will be return null
            } else if (this.probooksAccounts.length > 0 || this.probooksFreeFields.length > 0 || this.probooksSeries.length > 0 || this.probooksLocations.length > 0 || this.probooksSets.length > 0) {
                this.enableProBooks = true;
            }
        },

        async loadResources() {
            const responseRuleCollections = await this.oasisApi.get('/ruleCollections')
            this.ruleCollections = responseRuleCollections.data;
            const responseAllowanceRateUnits = await this.oasisV3Api.get('/optionValues?option_type_id=24&status=1')
            this.allowanceRateUnits = responseAllowanceRateUnits.data.results;
            const responseLegTypes = await this.oasisApi.get('/legislativeTypes')
            this.legislativeTypes = responseLegTypes.data;

            const responseStates = await this.oasisApi.get('/states')
            this.states = responseStates.data;

            const responseAllApproverByEntity = await this.oasisV3Api.getAllPages(`/employer/approvers?entity_id=${entityId}`);
            this.allApproverByEntity = responseAllApproverByEntity.data.results;

            const responseCoaRules = await this.oasisV3Api.get(`/employer/coaRules?entity_id=${entityId}`)
            this.coaRules = responseCoaRules.data.results;

            // we need to use UserRoleMx table to get username and userId from filtered data(entityId)
            const responseUserRoleMx = await this.oasisV3Api.get(`/employer/userroles?entity_id=${entityId}`);
            let removedDupUser = responseUserRoleMx.data.results;
            // need to remove duplicated values (ex, same userId with different role)
            removedDupUser.forEach((ele) => {
                if (!this.allUserbyEntity.has(ele.user_id)) {
                    this.allUserbyEntity.set(ele.user_id, ele.user);
                    this.allUserId.push(ele.user_id)
                }
            });

            const responseOptionValues = await this.oasisV3Api.get('/optionValues?option_type_id=15&status=1')
            this.allUnionHiredFrom = responseOptionValues.data.results;

            const responseAgreements = await this.oasisApi.get('/unions/agreements')
            if (responseAgreements && responseAgreements.data && responseAgreements.data.agreements) {
                this.agreements = responseAgreements.data.agreements || [];
                this.agreementLocals = responseAgreements.data.agreementLocals.sort((a,b) => {
                    if (a.union_local < b.union_local) return 1;
                    if (a.union_local > b.union_local) return -1;
                    if (a.union_local === b.union_local) return 0;
                }) || [];
                this.unionLocals = responseAgreements.data.locals || [];
                this.unionJobs = responseAgreements.data.jobs || [];
                this.unionJobRules = responseAgreements.data.unionJobRules || [];
                this.unionLocations = responseAgreements.data.locations || [];
                this.unionOnProd = responseAgreements.data.onProd || [];
                this.unionSchedules = responseAgreements.data.schedule || [];
            }
            if (Array.isArray(this.agreements) && this.agreements.length > 0) this.disabledFlsaTypes = ['4'];

            if (this.type === 'create') this.setDefaults(true);
        },

        fringeCheck(selectedData) {
            // if we got error case, this function will not be fired.
            let val = ''
            if (selectedData && selectedData.code) {
                val = selectedData.code;
                const setFringe = selectedData.code.substring(0,selectedData.code.length-2) + '99';
                let validate = this.probooksAccounts.findIndex((el) => { return el.code == setFringe });
    
                if (validate == -1) {
                    this.assignment.fringe_code = '';
                    this.selected_fringe_code = '';
                } else if (selectedData.code.length < 4) {
                    this.assignment.fringe_code = '';
                    this.selected_fringe_code = '';
                } else {
                    this.assignment.fringe_code = setFringe;
                    this.selected_fringe_code = setFringe;
                }
            } else if (selectedData) {
                // this case would be custom data instead of selection. (if we set mustMatch = false, we will get this case)
                val = selectedData;
            }

            this.modified = true;
            this.assignment.budget_code = val;

            return;
        },

        setFringe(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.fringe_code = val;
            return;
        },

        setFF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.free_field = val;
            return;
        },

        setFF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.free_field2 = val;
            return;
        },

        setSeries(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.series_code = val;
            return;
        },

        setLocation(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.location_code = val;
            return;
        },

        setSet(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.set_code = val;
            return;
        },

        pwFringeCheck(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) {
                val = selectedData.code;
                const setFringe = selectedData.code.substring(0,selectedData.code.length-2) + '99';
                let validate = this.probooksAccounts.findIndex((el) => { return el.code == setFringe });
    
                if (validate == -1) {
                    this.assignment.pw_fringe_code = '';
                    this.selected_pw_fringe_code = '';
                } else if (selectedData.code.length < 4) {
                    this.assignment.pw_fringe_code = '';
                    this.selected_pw_fringe_code = '';
                } else {
                    this.assignment.pw_fringe_code = setFringe;
                    this.selected_pw_fringe_code = setFringe;
                }
            } else if (selectedData) {
                // this case would be custom data instead of selection. (if we set mustMatch = false, we will get this case)
                val = selectedData;
            }

            this.modified = true;
            this.assignment.pw_budget_code = val;

            return;
        },

        setPWFringe(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pw_fringe_code = val;
            return;
        },

        setPWFF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pw_free_field = val;
            return;
        },

        setPWFF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pw_free_field2 = val;
            return;
        },

        setPWSeries(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pw_series_code = val;
            return;
        },

        setPWLocation(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pw_location_code = val;
            return;
        },

        setPWSet(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pw_set_code = val;
            return;
        },

        set_kr_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.kr_code = val;
            return;
        },

        set_kr_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.kr_free_field = val;
            return;
        },

        set_kr_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.kr_free_field2 = val;
            return;
        },

        set_krtax_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.krtax_code = val;
            return;
        },

        set_krtax_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.krtax_free_field = val;
            return;
        },

        set_krtax_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.krtax_free_field2 = val;
            return;
        },

        set_pd_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pd_code = val;
            return;
        },

        set_pd_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pd_free_field = val;
            return;
        },

        set_pd_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pd_free_field2 = val;
            return;
        },

        set_pd_taxable_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pd_taxable_code = val;
            return;
        },

        set_pdtax_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pdtax_free_field = val;
            return;
        },

        set_pdtax_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.pdtax_free_field2 = val;
            return;
        },

        set_lodging_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.lodging_code = val;
            return;
        },

        set_lodging_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.lodging_free_field = val;
            return;
        },

        set_lodging_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.lodging_free_field2 = val;
            return;
        },

        set_lodging_tax_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.lodging_tax_code = val;
            return;
        },

        set_lodging_tax_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.lodging_tax_free_field = val;
            return;
        },

        set_lodging_tax_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.lodging_tax_free_field2 = val;
            return;
        },

        set_phone_allow_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.phone_allow_code = val;
            return;
        },

        set_phone_allow_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.phone_allow_free_field = val;
            return;
        },

        set_phone_allow_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.phone_allow_free_field2 = val;
            return;
        },

        set_cr_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.cr_code = val;
            return;
        },

        set_cr_FF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.cr_free_field = val;
            return;
        },

        set_cr_FF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.cr_free_field2 = val;
            return;
        },

        set_agent_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.agent_code = val;
            return;
        },

        set_agent_free_field(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.agent_free_field = val;
            return;
        },

        set_agent_free_field2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.agent_free_field2 = val;
            return;
        },
        // to show combined information in multiselect list
        LocalWithAgreement ({ union_local, agreement }) {
            return `${union_local} — (${agreement})`
        },

        // Show scale only.  Do not do show any errors
        async loadScaleOnly() {
            // Need a minimum of data
            if (!this.assignment.agreement_id || !this.assignment.union_local_id || !this.assignment.union_schedule_id || !this.assignment.job_title_id) {
                this.scale = null;
                this.scaleMessage = '';
                return;
            }
            var options = {
                agreement_id: this.assignment.agreement_id,
                job_title_id: this.assignment.job_title_id,
                legislative_type_id: this.assignment.legislative_type_id,
                union_local_id: this.assignment.union_local_id,
                union_schedule_id: this.assignment.union_schedule_id,
                union_hired_from_id: this.assignment.union_hired_from_id
            };

            const minWageResponse = await this.oasisApi.post('/minimumWage', options);
            if (minWageResponse && minWageResponse.data && minWageResponse.data.scale) {
                const scaleData = minWageResponse.data.scale
                // Figure out which one
                if (this.scaleType === 'distant') this.scale = scaleData.scale_distant || scaleData.scale || null;
                else if (this.scaleType === 'productionCity') this.scale = scaleData.scale_production_cities || scaleData.scale || null;
                else if (this.scaleType === 'studio') this.scale = scaleData.scale || null;
                else this.scale = scaleData.scale || scaleData.scale || null;

                // Set Scale rate to hourly for ProPay
                // Get the scale for the current rate unit
                this.scaleMessage = this.calcAdjustedScale();
            }
        },
    },

    watch: {
        isPaidScale: async function(value) {
            if (value === true) {
                this.rateFieldDisabled = true;
                if (!this.currentOtRules) {
                    await this.getOtRules();
                }
                await this.checkMinWage();
                this.rateFieldDisabled = false;
            }
        }
    },

    beforeCreate() {
        this.oasisApi = new Axios('/restv2');
    },

    async created() {
        this.format = this.getDateFormat();
        if (rateUnits) this.rateUnits = JSON.parse(rateUnits);
        window.addEventListener("beforeunload", this.leavePage, false);

        // Need to load key elements first
        await this.loadMinResources();
        // Now load remaining elements
        // Copy start to a new assignment
        if (assignmentHash) {
            this.type = 'create';
            this.waiting = true;
            await this.loadResources();
            let a = await this.oasisApi.get('/assignments/' + assignmentHash);
            if (a && a.data) {
                this.copyAssignment(a.data);
            }
            this.waiting = false;
 
        } else if (typeof type !== 'undefined' && type === 'create') {
            this.type = 'create';
            this.loadResources();
        } else {
            this.type = 'edit';
            await this.loadResources();
            let responseAssignment = await this.oasisApi.get('/assignments/' + hash);
            let assignmentToLoad = responseAssignment.data;
            if (!assignmentToLoad) {
                this.createDialog({
                    "title": "Warning", "body": 'You do not have permissions to edit this start.',
                    "buttonNo": false,
                    "buttonYesLabel": "OK",
                    "buttonYesAction": function () { window.location.href = '/oasis/welcome/dashboard'; }
                });
            } else {
                this.getFilteredUnionLocalsByLocation(assignmentToLoad.location_id, assignmentToLoad.union_hired_from_id);
                // need to set only department_id manually in advance to use approver api call
                this.assignment.department_id = assignmentToLoad.department_id ? assignmentToLoad.department_id : '';
                this.getEmployee(assignmentToLoad);
                if (this.isCanada && parseInt(assignmentToLoad.flsa_type_id) === 3) {
                    this.lockedInclVac = true;
                }
            }
        }
        this.adminAccess = typeof adminAccess !== 'undefined' ? (adminAccess ? true : false) : false;
        // if admin user, can get edit permission for workflow
        if (this.adminAccess) this.deptApproverWorkflow = 1;
        else {
            this.deptApproverWorkflow = userDeptWorkFlow;
        }
        this.waiting = false;
    },

    mounted() {
        // vue-multiselect has a bug for tab key event. so we implement event via JQuery
        var vm = this;
        $('.multiselect__input').keydown(function (event) { // watch for keydown events on elements with class multiselect
            if (event.which === 9) { // if event is tab
               var e = $.Event('click'); // create click event
               if (!vm.assignment.union_local_id || (vm.assignment.union_local_id && vm.union_local_pointer != vm.$refs.agreementLocal.pointer)) $(event.target).parent().siblings().find('.multiselect__option--highlight').trigger(e); // triggered
            }
         });
        $("input[name='last_name']").focus();
        this.newLocationState = this.newLocation.defaultState;

        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        }
    }
}).mount("#start-app");